/*! sz-quiz v1.0.0 | (c) 2021  | <<<private>>> */
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
  
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
  
    return arr2;
  }
  
  module.exports = _arrayLikeToArray;
  },{}],2:[function(require,module,exports){
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  
  module.exports = _arrayWithHoles;
  },{}],3:[function(require,module,exports){
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
  
    return self;
  }
  
  module.exports = _assertThisInitialized;
  },{}],4:[function(require,module,exports){
  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
  
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  
  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
          args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);
  
        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }
  
        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }
  
        _next(undefined);
      });
    };
  }
  
  module.exports = _asyncToGenerator;
  },{}],5:[function(require,module,exports){
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  
  module.exports = _classCallCheck;
  },{}],6:[function(require,module,exports){
  function _classPrivateFieldGet(receiver, privateMap) {
    var descriptor = privateMap.get(receiver);
  
    if (!descriptor) {
      throw new TypeError("attempted to get private field on non-instance");
    }
  
    if (descriptor.get) {
      return descriptor.get.call(receiver);
    }
  
    return descriptor.value;
  }
  
  module.exports = _classPrivateFieldGet;
  },{}],7:[function(require,module,exports){
  function _classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = privateMap.get(receiver);
  
    if (!descriptor) {
      throw new TypeError("attempted to set private field on non-instance");
    }
  
    if (descriptor.set) {
      descriptor.set.call(receiver, value);
    } else {
      if (!descriptor.writable) {
        throw new TypeError("attempted to set read only private field");
      }
  
      descriptor.value = value;
    }
  
    return value;
  }
  
  module.exports = _classPrivateFieldSet;
  },{}],8:[function(require,module,exports){
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  
  module.exports = _createClass;
  },{}],9:[function(require,module,exports){
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
  
    return obj;
  }
  
  module.exports = _defineProperty;
  },{}],10:[function(require,module,exports){
  function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  
  module.exports = _getPrototypeOf;
  },{}],11:[function(require,module,exports){
  var setPrototypeOf = require("./setPrototypeOf");
  
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
  
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) setPrototypeOf(subClass, superClass);
  }
  
  module.exports = _inherits;
  },{"./setPrototypeOf":16}],12:[function(require,module,exports){
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  
  module.exports = _interopRequireDefault;
  },{}],13:[function(require,module,exports){
  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
  
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
  
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
  
    return _arr;
  }
  
  module.exports = _iterableToArrayLimit;
  },{}],14:[function(require,module,exports){
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  
  module.exports = _nonIterableRest;
  },{}],15:[function(require,module,exports){
  var _typeof = require("@babel/runtime/helpers/typeof");
  
  var assertThisInitialized = require("./assertThisInitialized");
  
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }
  
    return assertThisInitialized(self);
  }
  
  module.exports = _possibleConstructorReturn;
  },{"./assertThisInitialized":3,"@babel/runtime/helpers/typeof":18}],16:[function(require,module,exports){
  function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  
    return _setPrototypeOf(o, p);
  }
  
  module.exports = _setPrototypeOf;
  },{}],17:[function(require,module,exports){
  var arrayWithHoles = require("./arrayWithHoles");
  
  var iterableToArrayLimit = require("./iterableToArrayLimit");
  
  var unsupportedIterableToArray = require("./unsupportedIterableToArray");
  
  var nonIterableRest = require("./nonIterableRest");
  
  function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
  }
  
  module.exports = _slicedToArray;
  },{"./arrayWithHoles":2,"./iterableToArrayLimit":13,"./nonIterableRest":14,"./unsupportedIterableToArray":19}],18:[function(require,module,exports){
  function _typeof(obj) {
    "@babel/helpers - typeof";
  
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      module.exports = _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      module.exports = _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }
  
    return _typeof(obj);
  }
  
  module.exports = _typeof;
  },{}],19:[function(require,module,exports){
  var arrayLikeToArray = require("./arrayLikeToArray");
  
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
  }
  
  module.exports = _unsupportedIterableToArray;
  },{"./arrayLikeToArray":1}],20:[function(require,module,exports){
  module.exports = require("regenerator-runtime");
  
  },{"regenerator-runtime":21}],21:[function(require,module,exports){
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  var runtime = (function (exports) {
    "use strict";
  
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  
    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }
    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function(obj, key, value) {
        return obj[key] = value;
      };
    }
  
    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []);
  
      // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.
      generator._invoke = makeInvokeMethod(innerFn, self, context);
  
      return generator;
    }
    exports.wrap = wrap;
  
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
      try {
        return { type: "normal", arg: fn.call(obj, arg) };
      } catch (err) {
        return { type: "throw", arg: err };
      }
    }
  
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
  
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
  
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
  
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };
  
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype &&
        NativeIteratorPrototype !== Op &&
        hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }
  
    var Gp = GeneratorFunctionPrototype.prototype =
      Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunction.displayName = define(
      GeneratorFunctionPrototype,
      toStringTagSymbol,
      "GeneratorFunction"
    );
  
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function(method) {
        define(prototype, method, function(arg) {
          return this._invoke(method, arg);
        });
      });
    }
  
    exports.isGeneratorFunction = function(genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor
        ? ctor === GeneratorFunction ||
          // For the native GeneratorFunction constructor, the best we can
          // do is to check its .name property.
          (ctor.displayName || ctor.name) === "GeneratorFunction"
        : false;
    };
  
    exports.mark = function(genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }
      genFun.prototype = Object.create(Gp);
      return genFun;
    };
  
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
      return { __await: arg };
    };
  
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;
          if (value &&
              typeof value === "object" &&
              hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function(value) {
              invoke("next", value, resolve, reject);
            }, function(err) {
              invoke("throw", err, resolve, reject);
            });
          }
  
          return PromiseImpl.resolve(value).then(function(unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function(error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }
  
      var previousPromise;
  
      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function(resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
  
        return previousPromise =
          // If enqueue has been called before, then we want to wait until
          // all previous Promises have been resolved before calling invoke,
          // so that results are always delivered in the correct order. If
          // enqueue has not been called before, then it is important to
          // call invoke immediately, without waiting on a callback to fire,
          // so that the async generator function has the opportunity to do
          // any necessary setup in a predictable way. This predictability
          // is why the Promise constructor synchronously invokes its
          // executor callback, and why async functions synchronously
          // execute code before the first await. Since we implement simple
          // async functions in terms of async generators, it is especially
          // important to get this right, even though it requires care.
          previousPromise ? previousPromise.then(
            callInvokeWithMethodAndArg,
            // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg
          ) : callInvokeWithMethodAndArg();
      }
  
      // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).
      this._invoke = enqueue;
    }
  
    defineIteratorMethods(AsyncIterator.prototype);
    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };
    exports.AsyncIterator = AsyncIterator;
  
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
  
      var iter = new AsyncIterator(
        wrap(innerFn, outerFn, self, tryLocsList),
        PromiseImpl
      );
  
      return exports.isGeneratorFunction(outerFn)
        ? iter // If outerFn is a generator, return the full iterator.
        : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
          });
    };
  
    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
  
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }
  
        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          }
  
          // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
          return doneResult();
        }
  
        context.method = method;
        context.arg = arg;
  
        while (true) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
  
          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
  
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }
  
            context.dispatchException(context.arg);
  
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }
  
          state = GenStateExecuting;
  
          var record = tryCatch(innerFn, self, context);
          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done
              ? GenStateCompleted
              : GenStateSuspendedYield;
  
            if (record.arg === ContinueSentinel) {
              continue;
            }
  
            return {
              value: record.arg,
              done: context.done
            };
  
          } else if (record.type === "throw") {
            state = GenStateCompleted;
            // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.
            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    }
  
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];
      if (method === undefined) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;
  
        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined;
            maybeInvokeDelegate(delegate, context);
  
            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }
  
          context.method = "throw";
          context.arg = new TypeError(
            "The iterator does not provide a 'throw' method");
        }
  
        return ContinueSentinel;
      }
  
      var record = tryCatch(method, delegate.iterator, context.arg);
  
      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }
  
      var info = record.arg;
  
      if (! info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }
  
      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value;
  
        // Resume execution at the desired location (see delegateYield).
        context.next = delegate.nextLoc;
  
        // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.
        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined;
        }
  
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      }
  
      // The delegate iterator is finished, so forget it and continue with
      // the outer generator.
      context.delegate = null;
      return ContinueSentinel;
    }
  
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
  
    define(Gp, toStringTagSymbol, "Generator");
  
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    Gp[iteratorSymbol] = function() {
      return this;
    };
  
    Gp.toString = function() {
      return "[object Generator]";
    };
  
    function pushTryEntry(locs) {
      var entry = { tryLoc: locs[0] };
  
      if (1 in locs) {
        entry.catchLoc = locs[1];
      }
  
      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }
  
      this.tryEntries.push(entry);
    }
  
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }
  
    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{ tryLoc: "root" }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }
  
    exports.keys = function(object) {
      var keys = [];
      for (var key in object) {
        keys.push(key);
      }
      keys.reverse();
  
      // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.
      return function next() {
        while (keys.length) {
          var key = keys.pop();
          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        }
  
        // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.
        next.done = true;
        return next;
      };
    };
  
    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }
  
        if (typeof iterable.next === "function") {
          return iterable;
        }
  
        if (!isNaN(iterable.length)) {
          var i = -1, next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }
  
            next.value = undefined;
            next.done = true;
  
            return next;
          };
  
          return next.next = next;
        }
      }
  
      // Return an iterator with no values.
      return { next: doneResult };
    }
    exports.values = values;
  
    function doneResult() {
      return { value: undefined, done: true };
    }
  
    Context.prototype = {
      constructor: Context,
  
      reset: function(skipTempReset) {
        this.prev = 0;
        this.next = 0;
        // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.
        this.sent = this._sent = undefined;
        this.done = false;
        this.delegate = null;
  
        this.method = "next";
        this.arg = undefined;
  
        this.tryEntries.forEach(resetTryEntry);
  
        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" &&
                hasOwn.call(this, name) &&
                !isNaN(+name.slice(1))) {
              this[name] = undefined;
            }
          }
        }
      },
  
      stop: function() {
        this.done = true;
  
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;
        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }
  
        return this.rval;
      },
  
      dispatchException: function(exception) {
        if (this.done) {
          throw exception;
        }
  
        var context = this;
        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;
  
          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined;
          }
  
          return !! caught;
        }
  
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;
  
          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("END");
          }
  
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");
  
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
  
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
  
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
  
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
  
      abrupt: function(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev &&
              hasOwn.call(entry, "finallyLoc") &&
              this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
  
        if (finallyEntry &&
            (type === "break" ||
             type === "continue") &&
            finallyEntry.tryLoc <= arg &&
            arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }
  
        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;
  
        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }
  
        return this.complete(record);
      },
  
      complete: function(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }
  
        if (record.type === "break" ||
            record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "END";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }
  
        return ContinueSentinel;
      },
  
      finish: function(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
  
      "catch": function(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
  
        // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.
        throw new Error("illegal catch attempt");
      },
  
      delegateYield: function(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };
  
        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined;
        }
  
        return ContinueSentinel;
      }
    };
  
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
  
  }(
    // If this script is executing as a CommonJS module, use module.exports
    // as the regeneratorRuntime namespace. Otherwise create a new empty
    // object. Either way, the resulting object will be used to initialize
    // the regeneratorRuntime variable at the top of this file.
    typeof module === "object" ? module.exports : {}
  ));
  
  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
  
  },{}],22:[function(require,module,exports){
  "use strict";
  
  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  
  var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
  
  var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
  
  var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
  
  var _classPrivateFieldGet2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldGet"));
  
  var _EVENTS, _init, _trigger, _temp, _init2, _trigger2;
  
  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
  
  var toolBox = require('../tools/general-helpers');
  
  module.exports = (_temp = (_EVENTS = new WeakMap(), _init = new WeakSet(), _trigger = new WeakSet(), /*#__PURE__*/function () {
    // Dom root element, will be set after the mount.
    // Indicates wether a question is answered (all required answers are submitted)
    // value is updated in the @this.updateAnswer.
    // ex, single choices question is answered when a choice is selected.
    // ex, multi choices question is answered when at least x choice(s) are selected.
    // ex, email quetion is answered when the entered email is valid.
    // Indicates wether answers of the questions are valid (by default they are unless indicated otherwise)
    // ID of the dom root element.
    // Section type, could be one of many values.
    // Events emitted throughout the life cycle of a question.
    function Question(_quizManagerInstance, _options) {
      (0, _classCallCheck2.default)(this, Question);
  
      _trigger.add(this);
  
      _init.add(this);
  
      (0, _defineProperty2.default)(this, "settings", {});
      (0, _defineProperty2.default)(this, "template", "");
      (0, _defineProperty2.default)(this, "handle", "");
      (0, _defineProperty2.default)(this, "selectors", {
        "question_text": "[kqb-question]",
        "answers_container": "[kqb-answers]",
        "answer_input": "[kqb-error-message]",
        "error_message": "[kqb-error-message]",
        "navigation_next": "[kqb-next]",
        "navigation_prev": "[kqb-prev]"
      });
      (0, _defineProperty2.default)(this, "root", false);
      (0, _defineProperty2.default)(this, "answered", false);
      (0, _defineProperty2.default)(this, "valid_answers", true);
      (0, _defineProperty2.default)(this, "section_id", toolBox.makeId(5, {
        prefix: "step-container-"
      }));
      (0, _defineProperty2.default)(this, "section_type", "question");
  
      _EVENTS.set(this, {
        writable: true,
        value: {
          INIT: 'sz_quiz:init',
          MOUNT: 'sz_quiz:mount',
          UNMOUNT: 'sz_quiz:unmount',
          ERROR: 'sz_quiz:error',
          SUBMIT: 'sz_quiz:submit'
        }
      });
  
      _classPrivateMethodGet(this, _init, _init2).call(this, _quizManagerInstance, _options);
    }
  
    (0, _createClass2.default)(Question, [{
      key: "getHTML",
  
      /* PUBLIC FUNCTIONS */
  
      /* ---------------- */
      // Should be overridden by plugins.
      value: function getHTML() {
        return this.template;
      } // If implemented by extenders, will be called instead of the original reload.
      // customReload () {
      //     return this.template;
      // }
  
    }, {
      key: "onMount",
      value: function onMount() {
        console.log("onMount implementation is specific to each instance");
      }
    }, {
      key: "onUnmount",
      value: function onUnmount() {
        console.log("onUnmount implementation is specific to each instance");
      }
    }, {
      key: "onError",
      value: function onError() {
        console.log("onError implementation is specific to each instance");
      }
    }, {
      key: "onSuccessfulSubmit",
      value: function onSuccessfulSubmit() {
        console.log("onSuccessfulSubmit implementation is specific to each instance");
      }
    }, {
      key: "getStepHTML",
  
      /* PUBLIC FUNCTIONS */
  
      /* ---------------- */
      // Should never be modified by external plugins - for internal use.
      value: function getStepHTML() {
        return "<section id=\"".concat(this.section_id, "\" data-type=\"").concat(this.class, "-").concat(this.subclass, "\">").concat(this.getHTML(), "</section>");
      }
    }, {
      key: "reloadStep",
      value: function reloadStep(options) {
        _classPrivateMethodGet(this, _init, _init2).call(this, this.quiz_manager, options); // Call custom reloader.
  
  
        if (this.customReload && typeof customReload === "function") return this.customReload(); // Or replace 
  
        var html = this.getStepHTML();
        var oldBlock = document.getElementById(this.section_id);
        var newBlock = toolBox.htmlToElement(html);
        oldBlock.parentNode.replaceChild(newBlock, oldBlock);
      }
    }, {
      key: "isMounted",
      value: function isMounted() {
        // Assign dom element as an internal ref.
        this.root = document.getElementById(this.section_id);
        this.root.focus(); // Trigger mounted event.
  
        _classPrivateMethodGet(this, _trigger, _trigger2).call(this, "".concat(this.quiz_id, ":").concat(this.quiz_version, ":").concat((0, _classPrivateFieldGet2.default)(this, _EVENTS).MOUNT)); // Call onMounted if implemented.
  
  
        if (this.onMount && typeof this.onMount === 'function') this.onMount();
      }
    }, {
      key: "isUnmount",
      value: function isUnmount() {
        this.root = null; // remove event listeners.
  
        if (this.onUnmount && typeof this.onUnmount === 'function') this.onUnmount();
      }
    }, {
      key: "autoSubmit",
      value: function autoSubmit() {
        if (this.automatic_validation_when_possible) this.submit();
      }
    }, {
      key: "submit",
      value: function submit() {
        if (this.required && !this.answered || !this.valid_answers) return this.onError();
  
        if (this.submittable_data) {
          this.onSuccessfulSubmit.bind(this)();
          this.quiz_manager.addAnswers(this.submittable_data.id, this.submittable_data);
        }
  
        this.updateErrorMessage();
        this.quiz_manager.next();
  
        _classPrivateMethodGet(this, _trigger, _trigger2).call(this, "".concat(this.quiz_id, ":").concat(this.quiz_version, ":").concat((0, _classPrivateFieldGet2.default)(this, _EVENTS).SUBMIT));
      }
    }, {
      key: "updateErrorMessage",
  
      /** sets or removes */
      value: function updateErrorMessage(msg) {
        // Trigger event.
        if (msg) _classPrivateMethodGet(this, _trigger, _trigger2).call(this, "".concat(this.quiz_id, ":").concat(this.quiz_version, ":").concat((0, _classPrivateFieldGet2.default)(this, _EVENTS).ERROR)); // Update interface.
  
        var verb = msg ? 'setAttribute' : 'removeAttribute';
        var errorContainerEle = this.root.querySelector("[data-quiz-error-container]");
        if (!errorContainerEle) return;
        errorContainerEle[verb]("data-active", !!msg);
        var errorMessageEle = errorContainerEle.querySelector("[data-quiz-error-message]");
        if (!errorMessageEle) return;
        errorMessageEle.innerHTML = msg || "";
      }
    }]);
    return Question;
  }()), _init2 = function _init2(quizManagerInstance, options) {
    this.lang = quizManagerInstance.shop_lang; // Quiz meta info
  
    this.quiz_id = options.quiz_id;
    this.quiz_version = options.quiz_version; // Question meta info
  
    this.id = options.question.id;
    this.handle = options.question.handle;
    this.class = options.question.class;
    this.subclass = options.question.subclass; // Indicates whether an answer is required.
  
    this.required = options.required; // All slides should have a ref of the question manager.
  
    this.quiz_manager = quizManagerInstance;
    this.settings = options;
    this.validateButton = options.validateButton; // progress bar visibility state for this question
  
    this.enableProgress = options.enable_progress === false ? false : true;
    this.automatic_validation_when_possible = options.automatic_validation_when_possible;
    /**
     * Build sub-templates & master template.
     */
  
    var answers_html = false;
    var validate_html = false; // Build answers.
  
    var templatePostfix = options.question.answers_template || options.question.subclass;
    var answersTemplate = "question_answers_".concat(templatePostfix);
    if (answersTemplate && document.getElementById(answersTemplate)) answers_html = toolBox.renderTemplate(answersTemplate, {
      question: options.question,
      answers: options.answers
    }); // Build validate button
  
    if (this.validateButton) validate_html = toolBox.renderTemplate(this.validateButton.template_id, this.validateButton);
  
    if (!answers_html) {
      debugger;
      console.warn("[Alfred Quiz] Couldn't compile answers", {
        id: this.id,
        class: this.class,
        subclass: this.subclass
      });
    } // Build template.
  
  
    var layoutTemplate = toolBox.getProp(options, "question.layout", false);
    var layout = "question" + (layoutTemplate ? "-".concat(layoutTemplate) : "");
    var stepHTML = toolBox.renderTemplate(layout, {
      settings: {
        question: options.question,
        answers_html: answers_html,
        validate_html: validate_html,
        show_previous: true
      }
    }); // Wrap the template around a generic section to facilitate selection & management.
  
    this.template = stepHTML;
  
    _classPrivateMethodGet(this, _trigger, _trigger2).call(this, "".concat(this.quiz_id, ":").concat(this.quiz_version, ":").concat((0, _classPrivateFieldGet2.default)(this, _EVENTS).INIT));
  }, _trigger2 = function _trigger2(name) {
    var ele = document.querySelector(this.quiz_manager.anchor_id);
    if (!ele) return;
    var eventData = {
      bubbles: true
    };
    eventData.detail = {
      current_step: this,
      all_steps: this.quiz_manager.all_steps,
      all_answers: this.quiz_manager.all_answers
    };
    ele.dispatchEvent(new CustomEvent(name, eventData));
  }, _temp);
  
  },{"../tools/general-helpers":40,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/classPrivateFieldGet":6,"@babel/runtime/helpers/createClass":8,"@babel/runtime/helpers/defineProperty":9,"@babel/runtime/helpers/interopRequireDefault":12}],23:[function(require,module,exports){
  "use strict";
  
  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  
  var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
  
  var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
  
  var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
  
  var _classPrivateFieldGet2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldGet"));
  
  var _EVENTS, _init, _trigger, _temp, _init2, _trigger2;
  
  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
  
  var toolBox = require('../tools/general-helpers');
  
  module.exports = (_temp = (_EVENTS = new WeakMap(), _init = new WeakSet(), _trigger = new WeakSet(), /*#__PURE__*/function () {
    // Dom root element, will be set after the mount.
    // ID of the dom root element.
    // Events emitted throughout the life cycle of a question.
    function ResultSection(resultsManagerInstance, _options) {
      (0, _classCallCheck2.default)(this, ResultSection);
  
      _trigger.add(this);
  
      _init.add(this);
  
      (0, _defineProperty2.default)(this, "data", {});
      (0, _defineProperty2.default)(this, "template", "");
      (0, _defineProperty2.default)(this, "root", false);
      (0, _defineProperty2.default)(this, "section_id", toolBox.makeId(5, {
        prefix: "step-container-"
      }));
      (0, _defineProperty2.default)(this, "templateHTML", "");
  
      _EVENTS.set(this, {
        writable: true,
        value: {
          INIT: 'init',
          MOUNT: 'mount',
          UNMOUNT: 'unmount',
          ERROR: 'error',
          SUBMIT: 'submit'
        }
      });
  
      _classPrivateMethodGet(this, _init, _init2).call(this, resultsManagerInstance, _options);
    }
  
    (0, _createClass2.default)(ResultSection, [{
      key: "getHTML",
  
      /* PUBLIC FUNCTIONS */
  
      /* ---------------- */
      // Should be overridden by plugins.
      value: function getHTML() {
        return this.templateHTML;
      } // If implemented by extenders, will be called instead of the original reload.
      // customReload () {
      //     return this.template;
      // }
  
    }, {
      key: "onMount",
      value: function onMount() {
        console.log("onMount implementation is specific to each instance");
      }
    }, {
      key: "onUnmount",
      value: function onUnmount() {
        console.log("onUnmount implementation is specific to each instance");
      }
      /* PUBLIC FUNCTIONS */
  
      /* ---------------- */
      // Should never be modified by external plugins - for internal use.
  
    }, {
      key: "getSectionHTML",
      value: function getSectionHTML() {
        return "<section id=\"".concat(this.section_id, "\" data-section-type=\"").concat(this.type_id, "\">").concat(this.getHTML(), "</section>");
      }
    }, {
      key: "reload",
      value: function reload(data) {
        _classPrivateMethodGet(this, _init, _init2).call(this, this.results_manager, data); // Call custom reloader.
  
  
        if (this.customReload && typeof customReload === "function") return this.customReload(); // Or replace 
  
        var html = this.getStepHTML();
        var oldBlock = document.getElementById(this.section_id);
        var newBlock = toolBox.htmlToElement(html);
        oldBlock.parentNode.replaceChild(newBlock, oldBlock);
      }
    }, {
      key: "isMounted",
      value: function isMounted() {
        // Assign dom element as an internal ref.
        this.root = document.getElementById(this.section_id); // Trigger mounted event.
  
        _classPrivateMethodGet(this, _trigger, _trigger2).call(this, "".concat(this.quiz_id, ":").concat(this.quiz_version, ":").concat((0, _classPrivateFieldGet2.default)(this, _EVENTS).MOUNT)); // Call onMounted if implemented.
  
  
        if (this.onMount && typeof this.onMount === 'function') this.onMount();
      }
    }, {
      key: "isUnmount",
      value: function isUnmount() {
        this.root = null; // remove event listeners.
  
        if (this.onUnmount && typeof this.onUnmount === 'function') this.onUnmount();
      }
    }]);
    return ResultSection;
  }()), _init2 = function _init2(resultsManager, options) {
    // Result section meta info
    this.id = options.id;
    this.type_id = options.type_id; // All slides should have a ref of the results manager.
  
    this.results_manager = resultsManager;
    this.data = options.data;
    this.shop = options.shop; // Build answers.
  
    var templateId = "result_section_".concat(this.type_id);
    this.templateHTML = toolBox.renderTemplate(templateId, this.data);
  
    _classPrivateMethodGet(this, _trigger, _trigger2).call(this, "".concat((0, _classPrivateFieldGet2.default)(this, _EVENTS).INIT));
  }, _trigger2 = function _trigger2(name, data) {
    var ele = document.getElementById("#quiz");
    if (!ele) return;
    var eventData = {
      bubbles: true
    };
    if (data) eventData.detail = data;
    ele.dispatchEvent(new CustomEvent(name, eventData));
  }, _temp);
  
  },{"../tools/general-helpers":40,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/classPrivateFieldGet":6,"@babel/runtime/helpers/createClass":8,"@babel/runtime/helpers/defineProperty":9,"@babel/runtime/helpers/interopRequireDefault":12}],24:[function(require,module,exports){
  "use strict";
  
  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  
  var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
  
  var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
  
  var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
  
  var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
  
  var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
  
  var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
  
  var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
  
  var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
  
  var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
  
  var _classPrivateFieldSet2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldSet"));
  
  var _classPrivateFieldGet2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldGet"));
  
  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
  
  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
  
  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
  
  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
  
  function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
  
  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
  
  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
  
  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
  
  var Question = require('./extendables/question');
  
  var toolBox = require('./tools/general-helpers');
  
  require('./tools/events');
  
  require('./tools/trackers');
  
  var _Choices = require('./quiz_blocks/choices');
  
  var _SingleChoice = require('./quiz_blocks/single-choice');
  
  var _Email = require('./quiz_blocks/email');
  
  var _Text = require('./quiz_blocks/text');
  
  var _RangeSlider = require('./quiz_blocks/range-slider');
  
  var _Date = require('./quiz_blocks/date');
  
  var _Rating = require('./quiz_blocks/rating');
  
  var _Number = require('./quiz_blocks/number');
  
  var _ResultHero = require('./result_blocks/hero');
  
  var _ResultCards = require('./result_blocks/cards');
  
  var _ResultCollection = require('./result_blocks/collection');
  
  var _ResultScript = require('./result_blocks/script');
  
  var _ResultStyle = require('./result_blocks/style');
  
  var _step_types = new WeakMap();
  
  var _score = new WeakMap();
  
  var _user_steps = new WeakMap();
  
  var _user_answers = new WeakMap();
  
  var _current_user_step_index = new WeakMap();
  
  var _navigation = new WeakMap();
  
  var _progress = new WeakMap();
  
  var _validateButton = new WeakMap();
  
  var _step_animation = new WeakMap();
  
  var _alignment = new WeakMap();
  
  var _all_jumps = new WeakMap();
  
  var _has_logical_jumps = new WeakMap();
  
  var _automatic_validation_when_possible = new WeakMap();
  
  var _customResultHandler = new WeakMap();
  
  var _ids = new WeakMap();
  
  var _classes = new WeakMap();
  
  var _domAttributes = new WeakMap();
  
  var _selectors = new WeakMap();
  
  var _NAVIGATION_ACTIONS = new WeakMap();
  
  var _addPlugins = new WeakSet();
  
  var _getStepPlugins = new WeakSet();
  
  var _pluginsFactory = new WeakSet();
  
  var _getCustomResultPlugin = new WeakSet();
  
  var _triggerAction = new WeakSet();
  
  var _updateSteps = new WeakSet();
  
  var _getNewStep = new WeakSet();
  
  var _buildTargetSettings = new WeakSet();
  
  var _getNavigationOptions = new WeakSet();
  
  var _getValidateOptions = new WeakSet();
  
  var _getProgressOptions = new WeakSet();
  
  var _renderStep = new WeakSet();
  
  var _updateProgress = new WeakSet();
  
  var _updateNavigation = new WeakSet();
  
  var _getTarget = new WeakSet();
  
  var _isValidTarget = new WeakSet();
  
  var _hasLogicalJumps = new WeakSet();
  
  var _logicalJumpEvaluatorFactory = new WeakSet();
  
  var QuizMaster = /*#__PURE__*/function () {
    // All available native blocks
    // The score of the quiz.
    // All the slides/steps already passed by the user, the user journey through out the quiz so far.
    // All the answers in the customer journey.
    // ex. user_answers.{{ question_id }} = [] || "".
    // Zero based index of the current step in the user steps array.
    // If the quiz has logical jumps, this should always be the index of the last step in @user_steps,
    // Otherwise, it could the index of any of the other steps.
    // The questions list as received from the back
    // The answers list as received from the back
    // The answers list as received from the back
    // The answers list as received from the back
    // The answers list as received from the back
    // Animation options
    // Alignment options
    // The list of all possible jumps (logical or incremental) as received from the back
    // Determines if the the quiz has logical jumps
    // Validate answers automatically when possible. Ex, single choice questions.
    // A function which can be assigned via plugins if custom result is requried
    // quiz selectors
    function QuizMaster() {
      var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        anchor_id: "app-quiz_anchor",
        configurations: {},
        meta: {}
      };
  
      (0, _classCallCheck2.default)(this, QuizMaster);
  
      _logicalJumpEvaluatorFactory.add(this);
  
      _hasLogicalJumps.add(this);
  
      _isValidTarget.add(this);
  
      _getTarget.add(this);
  
      _updateNavigation.add(this);
  
      _updateProgress.add(this);
  
      _renderStep.add(this);
  
      _getProgressOptions.add(this);
  
      _getValidateOptions.add(this);
  
      _getNavigationOptions.add(this);
  
      _buildTargetSettings.add(this);
  
      _getNewStep.add(this);
  
      _updateSteps.add(this);
  
      _triggerAction.add(this);
  
      _getCustomResultPlugin.add(this);
  
      _pluginsFactory.add(this);
  
      _getStepPlugins.add(this);
  
      _addPlugins.add(this);
  
      _step_types.set(this, {
        writable: true,
        value: {
          question: {
            choices: _Choices,
            singlechoice: _SingleChoice,
            email: _Email,
            text: _Text,
            rangeslider: _RangeSlider,
            date: _Date,
            rating: _Rating,
            number: _Number
          }
        }
      });
  
      _score.set(this, {
        writable: true,
        value: -1
      });
  
      _user_steps.set(this, {
        writable: true,
        value: []
      });
  
      _user_answers.set(this, {
        writable: true,
        value: {}
      });
  
      _current_user_step_index.set(this, {
        writable: true,
        value: -1
      });
  
      (0, _defineProperty2.default)(this, "all_steps", {});
      (0, _defineProperty2.default)(this, "all_answers", {});
  
      _navigation.set(this, {
        writable: true,
        value: {}
      });
  
      _progress.set(this, {
        writable: true,
        value: {}
      });
  
      _validateButton.set(this, {
        writable: true,
        value: {}
      });
  
      _step_animation.set(this, {
        writable: true,
        value: {}
      });
  
      _alignment.set(this, {
        writable: true,
        value: {}
      });
  
      _all_jumps.set(this, {
        writable: true,
        value: {}
      });
  
      _has_logical_jumps.set(this, {
        writable: true,
        value: false
      });
  
      _automatic_validation_when_possible.set(this, {
        writable: true,
        value: true
      });
  
      _customResultHandler.set(this, {
        writable: true,
        value: null
      });
  
      _ids.set(this, {
        writable: true,
        value: {
          quizTemplate: "root"
        }
      });
  
      _classes.set(this, {
        writable: true,
        value: {
          quizStep: "quiz-step",
          quizCurrentStep: "quiz-step--current",
          quizActionPrevious: "quiz-step--action-previous",
          progressBarState: "enabled"
        }
      });
  
      _domAttributes.set(this, {
        writable: true,
        value: {
          quizAnchorSettings: "quiz-anchor-settings",
          previousButton: "data-quiz-back-button",
          questionNumber: "data-quiz-question-number",
          totalQuestions: "data-quiz-total-questions",
          progressBar: "data-quiz-progress-bar",
          progressBarStep: "data-quiz-progress-bar-step",
          progressBarPercent: "data-quiz-progress-bar-percent",
          submitQuestion: "data-question-submit"
        }
      });
  
      _selectors.set(this, {
        writable: true,
        value: {
          quizTemplate: "#".concat((0, _classPrivateFieldGet2.default)(this, _ids).quizTemplate),
          quizStepsContainer: "#steps-container",
          quizRoot: "#quiz",
          quizStep: ".".concat((0, _classPrivateFieldGet2.default)(this, _classes).quizStep),
          quizCurrentStep: ".".concat((0, _classPrivateFieldGet2.default)(this, _classes).quizCurrentStep),
          quizAnchor: "[".concat((0, _classPrivateFieldGet2.default)(this, _domAttributes).quizAnchorSettings, "]"),
          previousButton: "[".concat((0, _classPrivateFieldGet2.default)(this, _domAttributes).previousButton, "]"),
          questionNumber: "[".concat((0, _classPrivateFieldGet2.default)(this, _domAttributes).questionNumber, "]"),
          totalQuestions: "[".concat((0, _classPrivateFieldGet2.default)(this, _domAttributes).totalQuestions, "]"),
          progressBar: "[".concat((0, _classPrivateFieldGet2.default)(this, _domAttributes).progressBar, "]"),
          progressBarState: "[".concat((0, _classPrivateFieldGet2.default)(this, _classes).progressBarState, "]"),
          progressBarStep: "[".concat((0, _classPrivateFieldGet2.default)(this, _domAttributes).progressBarStep, "]"),
          progressBarPercent: "[".concat((0, _classPrivateFieldGet2.default)(this, _domAttributes).progressBarPercent, "]"),
          submitQuestion: "[".concat((0, _classPrivateFieldGet2.default)(this, _domAttributes).submitQuestion, "]")
        }
      });
  
      _NAVIGATION_ACTIONS.set(this, {
        writable: true,
        value: {
          PREVIOUS: "previous",
          NEXT: "next",
          END: "END"
        }
      });
  
      (0, _defineProperty2.default)(this, "addAnswers", /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(id, step) {
          var answer_id,
              _step,
              _args = arguments;
  
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  try {
                    // Add the index of the step in this customer's journy.
                    step.index = (0, _classPrivateFieldGet2.default)(this, _current_user_step_index) + 1; // Add answer to local variable.
  
                    (0, _classPrivateFieldGet2.default)(this, _user_answers)[id] = step; // Calculate score
  
                    (0, _classPrivateFieldSet2.default)(this, _score, 0);
  
                    for (answer_id in (0, _classPrivateFieldGet2.default)(this, _user_answers)) {
                      _step = (0, _classPrivateFieldGet2.default)(this, _user_answers)[answer_id];
                      (0, _classPrivateFieldSet2.default)(this, _score, (0, _classPrivateFieldGet2.default)(this, _score) + _step.answers.reduce(function (result, item) {
                        if (isNaN(item.score)) item.score = 0;
                        return (result || 0) + item.score;
                      }, 0));
                    } // Send answer back to be saved.
  
  
                    if (window.sendAnswer) window.sendAnswer(step, this.quiz_id, this.version); // Trigger GA event.
  
                    if (typeof ga != "undefined") ga("send", "event", "quiz_".concat(this.quiz_id, "_").concat(this.version), "question ".concat((0, _classPrivateFieldGet2.default)(this, _current_user_step_index), " >  ").concat(step.handle), step.answers.map(function (answer) {
                      return answer.handle;
                    }).join(','), 0); // Trigger Klaviyo event.
                  } catch (e) {
                    console.error("An error occured while addingAnswers", _args, e);
                  }
  
                case 1:
                case "END":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
  
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
      if (!_options.anchor_id || !document.querySelector(_options.anchor_id) || !_options.configurations || !Object.keys(_options.configurations).length || !_options.meta || !_options.meta.shop || !_options.meta.id || !_options.meta.v) return console.log("Couldn't initiate the QuizMaster, missing arguments", arguments); // constructor(quiz_configurations, meta_settings) {
  
      (0, _classPrivateFieldGet2.default)(this, _selectors).quizAnchor = _options.anchor_id;
      this.anchor_id = _options.anchor_id;
      /***  process meta settings  ***/
  
      if (typeof Shopify != 'undefined') {
        this.shop_lang = Shopify.locale;
      }
  
      if (_options.meta) {
        this.shop = _options.meta.shop;
        this.quiz_id = _options.meta.id;
        this.version = _options.meta.v;
        this.page = _options.meta.page;
      }
      /***  process quiz settings  ***/
  
  
      var settings = _options.configurations.settings;
      this.all_steps = _options.configurations.all_steps;
      this.all_answers = _options.configurations.answers;
      (0, _classPrivateFieldSet2.default)(this, _all_jumps, _options.configurations.logical_jumps);
      (0, _classPrivateFieldSet2.default)(this, _progress, settings.progress);
      (0, _classPrivateFieldSet2.default)(this, _navigation, settings.navigation);
      (0, _classPrivateFieldSet2.default)(this, _validateButton, settings.validate);
      (0, _classPrivateFieldSet2.default)(this, _step_animation, settings.step_animation);
      (0, _classPrivateFieldSet2.default)(this, _alignment, settings.css_desktop.content);
      (0, _classPrivateFieldSet2.default)(this, _automatic_validation_when_possible, toolBox.getProp(settings, "navigation.automatic_validation_when_possible", (0, _classPrivateFieldGet2.default)(this, _automatic_validation_when_possible)));
      (0, _classPrivateFieldSet2.default)(this, _has_logical_jumps, _classPrivateMethodGet(this, _hasLogicalJumps, _hasLogicalJumps2).bind(this)());
      var quizAnchor = document.querySelector((0, _classPrivateFieldGet2.default)(this, _selectors).quizAnchor);
      var quizAnchorOptions = {};
      quizAnchorOptions.group_navigation_progress = false;
      this.quiz_level_navigation = true;
  
      var navOptions = _classPrivateMethodGet(this, _getNavigationOptions, _getNavigationOptions2).call(this);
  
      quizAnchorOptions.navigation_html = toolBox.renderTemplate(navOptions.template_id, navOptions);
      this.progress_level_navigation = true;
  
      var progressOptions = _classPrivateMethodGet(this, _getProgressOptions, _getProgressOptions2).call(this);
  
      quizAnchorOptions.progress_html = toolBox.renderTemplate(progressOptions.template_id, progressOptions); // Build the entire template.
  
      quizAnchor.innerHTML = toolBox.renderTemplate((0, _classPrivateFieldGet2.default)(this, _ids).quizTemplate, quizAnchorOptions);
      var quizWrapper = document.querySelector((0, _classPrivateFieldGet2.default)(this, _selectors).quizRoot);
      /*** CUSTOM USER STYLES ***/
  
      /**************************/
  
      toolBox.loadStyles({
        object: {
          ":root": toolBox.getProp(settings, "css_desktop.root_var", {}),
          "#quiz": toolBox.getProp(settings, "css_desktop.root", {}),
          "#quiz .quiz-question__title": toolBox.getProp(settings, "css_desktop.question", {}),
          "#quiz .quiz__answer__label": toolBox.getProp(settings, "css_desktop.answer", {}),
          "#quiz .quiz-navigation-container": toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _navigation), "css.root", {}),
          "#quiz .quiz-navigation-container .button--nav-prev": toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _navigation), "css_desktop.previous", {}),
          "#quiz .quiz-navigation-container .button--nav-prev:hover": toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _navigation), "css_desktop.previous:hover", {}),
          "#quiz .quiz-navigation-container .button--nav-next": toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _navigation), "css_desktop.next", {}),
          "#quiz .quiz-navigation-container .button--nav-next:hover": toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _navigation), "css_desktop.next:hover", {}),
          "#quiz .quiz-validate-container .button--validate": toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _validateButton), "css_desktop.validate", {}),
          "#quiz .quiz-validate-container .button--validate:hover": toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _validateButton), "css_desktop.validate:hover", {})
        }
      });
      toolBox.loadStyles({
        max_width: "600px",
        object: {
          "#quiz": toolBox.getProp(settings, "css_mobile.root", {}),
          "#quiz .quiz-question__title": toolBox.getProp(settings, "css_mobile.question", {}),
          "#quiz .quiz__answer__label": toolBox.getProp(settings, "css_mobile.answer", {})
        }
      }); // Animation duration.
  
      toolBox.loadStyles({
        object: {
          "#quiz .quiz-step": {
            transitionDuration: toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _step_animation), "duration", "1000ms")
          }
        }
      });
      quizWrapper.classList.add( // Add navigation classes.
      "quiz--navigation-location-" + toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _navigation), "location", "top"), "quiz--navigation-layout-" + toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _navigation), "layout", "default"), "quiz--navigation-position-" + toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _navigation), "position", "default"), // Add progress classes.
      // "quiz--progress-position-" + toolBox.getProp(progress, "position", "fixed"),
      "quiz--progress-location-" + toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _progress), "location", "top"), // Add animation classes & styles.
      "quiz--animation-" + toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _step_animation), "transition", "fade"), // Add validate button classes.
      // "quiz--validate-button-position-" + toolBox.getProp(validateButton, "position", "fixed"),
      // Add quiz content classes.
      "quiz--content-alignment-" + toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _alignment), "alignment", "center"));
      /*** EVENT MANAGEMENT ***/
  
      /************************/
  
      /******* External Commands *******/
      // previous question
  
      document.addEventListener("question_prev", this.previous.bind(this)); // next question
  
      document.addEventListener("question_next", this.next.bind(this)); // reload question
  
      document.addEventListener("question_reload", this.reloadStep.bind(this)); // remount quiz
  
      document.addEventListener("remount_quiz", this.remount.bind(this)); // customize events
      // document.addEventListener('message', this.customizeEvent.bind(this));
  
      /******* Navigation *******/
  
      quizWrapper.addEventListener("click", function (e) {
        // Next
        if (e.target && e.target.closest("[kqb-next]") && !this.disable_next) {
          var currentStep = this.getCurrentStep();
          currentStep.submit();
        } // Previous
        else if (e.target && e.target.closest("[kqb-prev]") && !this.disable_previous) this.previous.bind(this)();
      }.bind(this));
      /*** ADD CUSTOM STEPS (PLUGINS) */
  
      /********************************/
  
      _classPrivateMethodGet(this, _addPlugins, _addPlugins2).call(this);
      /*** START QUIZ ***/
  
      /******************/
  
  
      this.next();
    }
    /* ---------------------------------------------------------------- */
  
    /* PRIVATE FUNCTIONS - PLUGINS MANAGEMENT */
  
    /* ---------------------------------------------------------------- */
  
  
    (0, _createClass2.default)(QuizMaster, [{
      key: "renderTemplate",
  
      /* ---------------------------------------------------------------- */
  
      /* PUBLIC FUNCTIONS */
  
      /* ---------------------------------------------------------------- */
      value: function renderTemplate(templateHTML) {
        console.log("render template", templateHTML);
      }
    }, {
      key: "getSteps",
      value: function getSteps() {
        return (0, _classPrivateFieldGet2.default)(this, _user_steps);
      }
    }, {
      key: "getCurrentStep",
      value: function getCurrentStep() {
        return (0, _classPrivateFieldGet2.default)(this, _user_steps)[(0, _classPrivateFieldGet2.default)(this, _current_user_step_index)];
      }
      /**
       * 
       * @param {bool} asArray Indicates if the desired output is an array, otherwise it'll be an object.
       */
  
    }, {
      key: "getAnswers",
      value: function getAnswers(asArray) {
        var _this = this;
  
        if (asArray) return Object.keys((0, _classPrivateFieldGet2.default)(this, _user_answers)).map(function (id) {
          return (0, _classPrivateFieldGet2.default)(_this, _user_answers)[id];
        });
        return (0, _classPrivateFieldGet2.default)(this, _user_answers);
      }
    }, {
      key: "deleteAnswer",
      value: function deleteAnswer(id) {
        if (window.deleteAnswer) window.deleteAnswer(id, this.quiz_id, this.version);
      }
    }, {
      key: "next",
      value: function next() {
        // update quiz.
        return _classPrivateMethodGet(this, _triggerAction, _triggerAction2).bind(this)((0, _classPrivateFieldGet2.default)(this, _NAVIGATION_ACTIONS).NEXT);
      }
    }, {
      key: "previous",
      value: function previous() {
        if (!(0, _classPrivateFieldGet2.default)(this, _user_steps) || !Array.isArray((0, _classPrivateFieldGet2.default)(this, _user_steps)) || (0, _classPrivateFieldGet2.default)(this, _user_steps).length <= 1) return this; // delete current answer (if it exists).
  
        var currentStep = this.getCurrentStep();
        this.deleteAnswer(currentStep.id); // update steps.
  
        return _classPrivateMethodGet(this, _triggerAction, _triggerAction2).bind(this)((0, _classPrivateFieldGet2.default)(this, _NAVIGATION_ACTIONS).PREVIOUS);
      }
    }, {
      key: "goTo",
      // NOTE: This is intended to by used by the customize (or for initialization) & not by the normal user.
      value: function goTo(target) {
        console.log("goTo ".concat(target), !_classPrivateMethodGet(this, _hasLogicalJumps, _hasLogicalJumps2).call(this, target));
        if (!_classPrivateMethodGet(this, _hasLogicalJumps, _hasLogicalJumps2).call(this, target)) return this;
        var stepIndex = (0, _classPrivateFieldGet2.default)(this, _user_steps).findIndex(function (s) {
          return s.settings.question.id === target;
        });
  
        if (stepIndex > -1) {
          // if @target is the current step => do nothing.
          if (stepIndex == (0, _classPrivateFieldGet2.default)(this, _user_steps).length - 1) return this; // if @target is the previous step => call previous.
          else if (stepIndex == (0, _classPrivateFieldGet2.default)(this, _user_steps).length - 2) return this.previous(); // if @target is a previous step (not the previous) =>
            else {
                // Back to previous step & then one step back.
                _classPrivateMethodGet(this, _updateSteps, _updateSteps2).call(this, (0, _classPrivateFieldGet2.default)(this, _NAVIGATION_ACTIONS).PREVIOUS);
  
                _classPrivateMethodGet(this, _updateSteps, _updateSteps2).call(this, (0, _classPrivateFieldGet2.default)(this, _NAVIGATION_ACTIONS).PREVIOUS); // Recursive goTo call.
  
  
                return this.goTo(target);
              }
        } // If @target is not one of the previous steps, add it as the next question.
  
  
        return this.next(target);
      }
    }, {
      key: "reloadStep",
      value: function reloadStep(data) {
        var currentStep = this.getCurrentStep();
        var target = currentStep.id;
        var steps = data.all_steps;
        var answers = data.answers;
  
        var options = _classPrivateMethodGet(this, _buildTargetSettings, _buildTargetSettings2).call(this, target, steps, answers);
  
        return currentStep.reloadStep(options);
      }
    }, {
      key: "remount",
      value: function remount(quiz_data) {
        QuizMaster.bind(this)({
          anchor_id: (0, _classPrivateFieldGet2.default)(this, _selectors).quizAnchor,
          configurations: quiz_data,
          meta: {
            shop: this.shop,
            id: this.quiz_id,
            v: this.version,
            page: this.page
          }
        });
      }
    }, {
      key: "submitQuestion",
      value: function submitQuestion() {}
    }, {
      key: "submitQuiz",
      value: function submitQuiz() {
        // Execute custom result handler if exists.
        if ((0, _classPrivateFieldGet2.default)(this, _customResultHandler) && typeof (0, _classPrivateFieldGet2.default)(this, _customResultHandler) === 'function') return (0, _classPrivateFieldGet2.default)(this, _customResultHandler).call(this, (0, _classPrivateFieldGet2.default)(this, _user_answers)).bind(this); // Otherwise execute normal behaviour.
  
        var urlParams = new URLSearchParams(window.location.search);
        var urlLang = urlParams.get('lang');
        var resultsUrl = "/apps/quiz?quiz_id=".concat(this.quiz_id, "&v=").concat(this.version, "&page=results&q=").concat(Date.now(), "&session=").concat(kqb_session_token);
        if (urlLang) resultsUrl += "&lang=".concat(urlLang);
        setTimeout(function () {
          window.location.href = resultsUrl;
          console.log("END: Quiz submited");
        }, 600);
      }
    }, {
      key: "logSteps",
      value: function logSteps() {
        console.log((0, _classPrivateFieldGet2.default)(this, _user_steps));
      }
    }, {
      key: "getSteps",
      value: function getSteps() {
        return (0, _classPrivateFieldGet2.default)(this, _user_steps);
      }
    }]);
    return QuizMaster;
  }();
  
  var _addPlugins2 = function _addPlugins2() {
    // Get custom steps.
    var pluginsConfigurations = _classPrivateMethodGet(this, _getStepPlugins, _getStepPlugins2).call(this);
  
    var _iterator3 = _createForOfIteratorHelper(pluginsConfigurations),
        _step4;
  
    try {
      for (_iterator3.s(); !(_step4 = _iterator3.n()).done;) {
        var config = _step4.value;
  
        var plugin = _classPrivateMethodGet(this, _pluginsFactory, _pluginsFactory2).call(this, config);
  
        (0, _classPrivateFieldGet2.default)(this, _step_types)[config.class][config.subclass] = plugin;
      } // Get custom result action.
  
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  
    (0, _classPrivateFieldSet2.default)(this, _customResultHandler, _classPrivateMethodGet(this, _getCustomResultPlugin, _getCustomResultPlugin2).call(this));
  };
  
  var _getStepPlugins2 = function _getStepPlugins2() {
    var validPlugins = [];
    var pluginSteps = toolBox.getProp(window, "__quizPlugins.steps", false);
  
    if (!pluginSteps) {
      console.info('No plugins found.');
      return validPlugins;
    } else if (!Array.isArray(pluginSteps) || !pluginSteps.length) {
      console.info('__quizPlugins.steps should be a non-empty array.');
      return validPlugins;
    }
  
    var requiredFunctions = ["onInit", "getHTML", "onMount", "onUnmount", "onError", "onSuccessfulSubmit"];
    var requiredProperties = [{
      name: "class",
      type: "string"
    }, {
      name: "subclass",
      type: "string"
    }];
  
    var _iterator4 = _createForOfIteratorHelper(pluginSteps),
        _step5;
  
    try {
      for (_iterator4.s(); !(_step5 = _iterator4.n()).done;) {
        var plugin = _step5.value;
  
        // Check required function.
        var _iterator5 = _createForOfIteratorHelper(requiredFunctions),
            _step6;
  
        try {
          for (_iterator5.s(); !(_step6 = _iterator5.n()).done;) {
            var functionName = _step6.value;
  
            if (!plugin[functionName] || typeof plugin[functionName] !== 'function') {
              console.error("Invalid plugin, ".concat(functionName, " implementation is missing. Required functions are : ").concat(requiredFunctions.join(', ')));
              continue;
            }
          } // Check required properties.
  
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
  
        var _iterator6 = _createForOfIteratorHelper(requiredProperties),
            _step7;
  
        try {
          for (_iterator6.s(); !(_step7 = _iterator6.n()).done;) {
            var prop = _step7.value;
  
            if (!plugin[prop.name] || (0, _typeof2.default)(plugin[prop.name]) !== prop.type) {
              console.error("Invalid plugin, ".concat(prop.name, " is required & should be of type ").concat(prop.type, ". Required properties are : ").concat(requiredProperties.map(function (p) {
                return p.name;
              }).join(', ')));
            }
          } // Check if it already exists.
  
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
  
        if ((0, _classPrivateFieldGet2.default)(this, _step_types)[plugin.class][plugin.subclass]) {
          console.error("Invalid plugin. A question with [class: ".concat(plugin.class, "][ subclass").concat(plugin.subclass, "] already exists"));
          continue;
        }
  
        validPlugins.push(plugin);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  
    return validPlugins;
  };
  
  var _pluginsFactory2 = function _pluginsFactory2(configurations) {
    return /*#__PURE__*/function (_Question) {
      (0, _inherits2.default)(CustomStep, _Question);
  
      var _super = _createSuper(CustomStep);
  
      // #_EVENTS  = null;
      // #_trigger = null;
      function CustomStep(quizManagerInstance, options) {
        var _this2;
  
        (0, _classCallCheck2.default)(this, CustomStep);
        // Call Question's constructor.
        _this2 = _super.call(this, quizManagerInstance, options); // this.#_EVENTS  = this.#EVENTS || {};
        // this.#_trigger = this.#trigger || function () {}; 
        // Assign input configs as public properties & functions. 
  
        var _loop = function _loop(key) {
          var value = configurations[key];
  
          if (typeof value === 'function') {
            _this2[key] = function () {
              try {
                // function triggerEvent() {
                // let event = "";
                // let data = {}; 
                //   switch (key) {
                //     case 'init':
                //       event = `${this.quiz_id}:${this.quiz_version}:${this.#_EVENTS.INIT}`;
                //       break;
                //     case 'mount':
                //       event = `${this.quiz_id}:${this.quiz_version}:${this.#_EVENTS.MOUNT}`;
                //       break;
                //     case 'unmount':
                //       event = `${this.quiz_id}:${this.quiz_version}:${this.#_EVENTS.UNMOUNT}`;
                //       break;
                //     default:
                //       break;
                //   }
                //   this.#_trigger(event, data);
                // }
                // setImmediate(triggerEvent.bind(this)());
                return value.bind(this)(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
              } catch (e) {
                console.error("Error executing ".concat(key, " of quiz plugin"), e);
              }
            };
          } else {
            _this2[key] = value;
          }
        };
  
        for (var key in configurations) {
          _loop(key);
        } // Call the init function.
  
  
        _this2.onInit();
  
        return _this2;
      }
  
      return CustomStep;
    }(Question);
  };
  
  var _getCustomResultPlugin2 = function _getCustomResultPlugin2() {
    var customResult = toolBox.getProp(window, "__quizPlugins.onResult", false);
  
    if (!customResult || typeof customResult !== 'function') {
      console.info("No custom result found. If you'd like to add custom result management, please add a function : window.__quizPlugins.onResult");
      return null;
    }
  
    return customResult;
  };
  
  var _triggerAction2 = function _triggerAction2(action) {
    if (!this.all_steps.length) return;
    // var duration = (0, _classPrivateFieldGet2.default)(this, _step_animation).duration || 300;
    // document.getElementsByClassName("quiz-navigation-container")[0].classList.add("hidden");
    // document.getElementsByClassName("quiz-progress-container")[0].classList.add("hidden");
    // setTimeout(function () {
    //   document.getElementsByClassName("quiz-navigation-container")[0].classList.remove("hidden");
    //   document.getElementsByClassName("quiz-progress-container")[0].classList.remove("hidden");
    // }, duration);
    if (action == (0, _classPrivateFieldGet2.default)(this, _NAVIGATION_ACTIONS).END || !_classPrivateMethodGet(this, _updateSteps, _updateSteps2).bind(this)(action)) return this.submitQuiz();
  
    _classPrivateMethodGet(this, _renderStep, _renderStep2).bind(this)(action);
  
    _classPrivateMethodGet(this, _updateProgress, _updateProgress2).bind(this)();
  
    _classPrivateMethodGet(this, _updateNavigation, _updateNavigation2).bind(this)(action);
  };
  
  var _updateSteps2 = function _updateSteps2(action) {
    switch (action) {
      // END => No need to keep a ref of the current step as the quiz is finished.
      case (0, _classPrivateFieldGet2.default)(this, _NAVIGATION_ACTIONS).END:
        (0, _classPrivateFieldSet2.default)(this, _current_user_step_index, Infinity);
        break;
  
      case (0, _classPrivateFieldGet2.default)(this, _NAVIGATION_ACTIONS).PREVIOUS:
        // If the quiz has logical jumps,
        // => delete the current question because when going back & changing the answer could result in altering the next question.
        if ((0, _classPrivateFieldGet2.default)(this, _has_logical_jumps)) (0, _classPrivateFieldGet2.default)(this, _user_steps).pop();
        (0, _classPrivateFieldSet2.default)(this, _current_user_step_index, +(0, _classPrivateFieldGet2.default)(this, _current_user_step_index) - 1);
        break;
      // NEXT =>
  
      case (0, _classPrivateFieldGet2.default)(this, _NAVIGATION_ACTIONS).NEXT:
        // Default value is -1 incase this is the beginning of the quiz.
        var newStepIndex = (0, _classPrivateFieldGet2.default)(this, _current_user_step_index) + 1; // Default target is an existing target => no need to add "newTarget".
        // Case of revisiting an older (not the latest) => The next step already exists.
  
        var newTarget = false; // Add the first step
  
        if (newStepIndex == 0) newTarget = this.all_steps[newStepIndex].id; // The quiz has logical jumps
        // => we ought to add a new step which should be calculate based on the current question/answers.
        else if ((0, _classPrivateFieldGet2.default)(this, _has_logical_jumps)) {
            var currentStep = this.getCurrentStep();
            ; // Get the target/id of the next **logical** step based on the current question/answers/score ...
  
            newTarget = _classPrivateMethodGet(this, _getTarget, _getTarget2).call(this, currentStep);
          } // If the user is on the newest step,
          // => The next question doesn't exist yet & should be added.
          else if ((0, _classPrivateFieldGet2.default)(this, _current_user_step_index) == (0, _classPrivateFieldGet2.default)(this, _user_steps).length - 1 && newStepIndex < this.all_steps.length) newTarget = this.all_steps[newStepIndex].id; // If the user reached the end of the available slides => next target is the end.
            else if ((0, _classPrivateFieldGet2.default)(this, _current_user_step_index) == (0, _classPrivateFieldGet2.default)(this, _user_steps).length - 1) newTarget = (0, _classPrivateFieldGet2.default)(this, _NAVIGATION_ACTIONS).END; // update the current step index.
  
        (0, _classPrivateFieldSet2.default)(this, _current_user_step_index, newStepIndex); // Actions based on the next step.
  
        if (newTarget == (0, _classPrivateFieldGet2.default)(this, _NAVIGATION_ACTIONS).END) return false;else if (newTarget) {
          var newStep = _classPrivateMethodGet(this, _getNewStep, _getNewStep2).bind(this)(newTarget);
  
          (0, _classPrivateFieldGet2.default)(this, _user_steps).push(newStep);
        }
        break;
    }
  
    return true;
  };
  
  var _getNewStep2 = function _getNewStep2(target) {
    // otherwise, build next slide settings.
    var options = _classPrivateMethodGet(this, _buildTargetSettings, _buildTargetSettings2).call(this, target, this.all_steps, this.all_answers);
  
    return new ((0, _classPrivateFieldGet2.default)(this, _step_types)[options.question.class][options.question.subclass])(this, options);
  };
  
  var _buildTargetSettings2 = function _buildTargetSettings2(target, steps, answers) {
    // otherwise, build next slide settings.
    var stepContext = steps.find(function (step) {
      return step.id === target;
    });
    var nextStepSettings = {
      quiz_id: this.quiz_id,
      quiz_version: this.version,
      question: stepContext,
      answers: answers[target],
      required: stepContext.required === false ? false : true,
      automatic_validation_when_possible: (0, _classPrivateFieldGet2.default)(this, _automatic_validation_when_possible)
    };
    if (toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _validateButton), 'enabled', false)) nextStepSettings.validateButton = _classPrivateMethodGet(this, _getValidateOptions, _getValidateOptions2).call(this);
    return nextStepSettings;
  };
  
  var _getNavigationOptions2 = function _getNavigationOptions2() {
    return {
      template_id: "navigation",
      settings: {
        show_previous: (0, _classPrivateFieldGet2.default)(this, _current_user_step_index) > 0 ? true : false,
        show_next: true,
        show_arrow: (0, _classPrivateFieldGet2.default)(this, _navigation).arrows // commented because useful for later. The problem is that next & submit are the same for the moment.
        // show_next: current_user_step_index0 == all_steps.length - 1? false:true
  
      },
      labels: toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _navigation), "labels", {})
    };
  };
  
  var _getValidateOptions2 = function _getValidateOptions2() {
    return {
      template_id: "validate",
      settings: {
        show_validate: true // commented because useful for later. The problem is that next & submit are the same for the moment.
  
      },
      labels: toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _validateButton), "labels", {})
    };
  };
  
  var _getProgressOptions2 = function _getProgressOptions2() {
    return {
      template_id: "progress",
      // TODO MOAAZ
      settings: {
        layout: (0, _classPrivateFieldGet2.default)(this, _progress).layout,
        all_steps: this.all_steps
      },
      labels: toolBox.getProp((0, _classPrivateFieldGet2.default)(this, _progress), "labels", {})
    };
  };
  
  var _renderStep2 = function _renderStep2(action) {
    // Get all HTML steps that are already rendered on the webpage.
    var slides = document.querySelectorAll((0, _classPrivateFieldGet2.default)(this, _selectors).quizStep); // Get selected slide (next or previous). Default case, the slide already exists on the webpage.
  
    var newSlide = slides[(0, _classPrivateFieldGet2.default)(this, _current_user_step_index)]; // In case a new step is added to the user_steps (but not yet to the webpage)
  
    if (!newSlide) {
      var newSlideId = "step-".concat((0, _classPrivateFieldGet2.default)(this, _current_user_step_index));
  
      var _currentStep = this.getCurrentStep(); // Build next step's container.
  
  
      newSlide = document.createElement("div");
      newSlide.setAttribute("id", newSlideId);
      newSlide.classList.add((0, _classPrivateFieldGet2.default)(this, _classes).quizStep, "quiz-step--animate-out-previous");
      newSlide.innerHTML = _currentStep.getStepHTML(); // Append it to the view.
  
      document.querySelector((0, _classPrivateFieldGet2.default)(this, _selectors).quizStepsContainer).appendChild(newSlide); // Add the step to it container. (current_user_step_index0 should be equal to user_steps.length-1)
  
      _currentStep.isMounted();
    } // Get the current HTML step & remove the class indicating that it is the current step.
  
  
    var currentStep = false;
  
    if (slides.length) {
      // Select the current slide using the class selector.
      currentStep = document.querySelector((0, _classPrivateFieldGet2.default)(this, _selectors).quizCurrentStep); // Remove the element from being the current one.
  
      currentStep.classList.remove((0, _classPrivateFieldGet2.default)(this, _classes).quizCurrentStep, "quiz-step--animate-out-previous", "quiz-step--animate-out-next", "quiz-step--animate-in");
    } // Designate the new slide as the current step. (instead of the current one)
  
  
    newSlide.classList.add((0, _classPrivateFieldGet2.default)(this, _classes).quizCurrentStep); // Animate slides.
  
    setTimeout(function () {
      newSlide.classList.remove("quiz-step--animate-out-previous", "quiz-step--animate-out-next");
      newSlide.classList.add("quiz-step--animate-in");
  
      if (action == (0, _classPrivateFieldGet2.default)(this, _NAVIGATION_ACTIONS).PREVIOUS) {
        if (currentStep) currentStep.classList.add("quiz-step--animate-out-previous");
        if ((0, _classPrivateFieldGet2.default)(this, _has_logical_jumps)) setTimeout(function () {
          if (currentStep) currentStep.remove();
        }, 0);
      } else if (action == (0, _classPrivateFieldGet2.default)(this, _NAVIGATION_ACTIONS).NEXT) {
        if (currentStep) currentStep.classList.add("quiz-step--animate-out-next");
      }
    }.bind(this), 0);
  };
  
  var _updateProgress2 = function _updateProgress2() {
    var _this4 = this;
  
    var currentStepIndex = (0, _classPrivateFieldGet2.default)(this, _current_user_step_index) + 1;
  
    var progressState = function (state) {
      var _this3 = this;
  
      document.querySelectorAll((0, _classPrivateFieldGet2.default)(this, _selectors).progressBar).forEach(function (ele, key) {
        ele.classList[state ? 'add' : 'remove']((0, _classPrivateFieldGet2.default)(_this3, _selectors).progressBarState);
      });
    }.bind(this);
  
    if (!(0, _classPrivateFieldGet2.default)(this, _user_steps)[currentStepIndex - 1].enableProgress) {
      progressState(false);
    } else if ((0, _classPrivateFieldGet2.default)(this, _has_logical_jumps)) {
      progressState(true);

      // === Get current step id
      let currentStepId = null;
      const currentStep = document.querySelector((0, _classPrivateFieldGet2.default)(this, _selectors).quizCurrentStep);
      if (currentStep !== null && currentStep !== undefined) {
        currentStepId = currentStep.querySelector('[data-question]').id;
      }

      // === Get current step index
      if (currentStepId !== null && currentStepId !== undefined) {
        for (let index = 0; index < _this4.all_steps.length; index++) {
          const step = _this4.all_steps[index];
          if (step.id === currentStepId) {
            currentStepIndex = index + 1;
          }
        }
      }

      // === Update progress bar
      document.querySelectorAll((0, _classPrivateFieldGet2.default)(this, _selectors).progressBar).forEach(function (ele, key) {
        ele.style.width = "".concat(Math.round(currentStepIndex / _this4.all_steps.length * 100), "%");
      });

    } else {
      progressState(true);
      document.querySelectorAll((0, _classPrivateFieldGet2.default)(this, _selectors).questionNumber).forEach(function (ele, key) {
        ele.innerHTML = currentStepIndex;
      });
      var percent = Math.round(currentStepIndex / this.all_steps.length * 100);
      document.querySelectorAll((0, _classPrivateFieldGet2.default)(this, _selectors).progressBarPercent).forEach(function (ele, key) {
        ele.innerHTML = percent + "%";
      });
      var stepIndex = currentStepIndex - 1;
      document.querySelectorAll((0, _classPrivateFieldGet2.default)(this, _selectors).progressBarStep).forEach(function (ele, key) {
        if (stepIndex >= key) {
          ele.classList.add("active");
        } else {
          ele.classList.remove("active");
        }
      });
      document.querySelectorAll((0, _classPrivateFieldGet2.default)(this, _selectors).progressBar).forEach(function (ele, key) {
        ele.style.width = "".concat(Math.round(currentStepIndex / _this4.all_steps.length * 100), "%");
      }); // Set the total number of questions.
  
      document.querySelectorAll((0, _classPrivateFieldGet2.default)(this, _selectors).totalQuestions).forEach(function (ele, key) {
        ele.innerHTML = _this4.all_steps.length;
      });
    }
  };
  
  var _updateNavigation2 = function _updateNavigation2(action) {
    if (!this.quiz_level_navigation) {
      if ((0, _classPrivateFieldGet2.default)(this, _NAVIGATION_ACTIONS).PREVIOUS == action) {
        // We enter this function after updating steps. 
        // So at this point, the current step is already the previous.
        // Add a specific class to indicate that the we're in a re-visit state. (for example, show buttons, specific info etc..)
        var currentStep = document.querySelector((0, _classPrivateFieldGet2.default)(this, _selectors).quizCurrentStep);
        currentStep.classList.add((0, _classPrivateFieldGet2.default)(this, _classes).quizActionPrevious);
      } else if ((0, _classPrivateFieldGet2.default)(this, _NAVIGATION_ACTIONS).NEXT == action && (0, _classPrivateFieldGet2.default)(this, _current_user_step_index) > 0) {
        // Remove the custom class from the previous step that indicates the state
        var htmlSteps = document.getElementsByClassName((0, _classPrivateFieldGet2.default)(this, _classes).quizStep);
        var previousHtmlStep = htmlSteps[(0, _classPrivateFieldGet2.default)(this, _current_user_step_index) - 1];
        previousHtmlStep.classList.remove((0, _classPrivateFieldGet2.default)(this, _classes).quizActionPrevious);
      }
  
      return;
    }
  
    var options = _classPrivateMethodGet(this, _getNavigationOptions, _getNavigationOptions2).call(this);
  
    
    var closeAction = !options.settings.show_previous ? "remove" : "add";
    var previousAction = options.settings.show_previous ? "remove" : "add";
    var nextAction = options.settings.show_next || (0, _classPrivateFieldGet2.default)(this, _NAVIGATION_ACTIONS).PREVIOUS == action ? "remove" : "add";
    if (document.querySelector('[kqb-close]')) {
      document.querySelector('[kqb-close]').classList[closeAction]('hidden');
    }
    if (document.querySelector('[kqb-prev]')) {
      document.querySelector('[kqb-prev]').classList[previousAction]('hidden');
    }
    if (document.querySelector('[kqb-next]')) {
      document.querySelector('[kqb-next]').classList[nextAction]('hidden');
    }
    this.disable_previous = previousAction == 'add';
    this.disable_next = nextAction == 'add';
  };
  
  var _getTarget2 = function _getTarget2(step) {
    var _this5 = this;
  
    // Default value end of quiz if no other valid value is found.
    var target = "END";
    var lj = (0, _classPrivateFieldGet2.default)(this, _all_jumps)[step.settings.question.id] || {};
    var lj_list = toolBox.getProp(lj, "list", []);
    var default_target = toolBox.getProp(lj, "default_target", ""); // Try to look for logical jumps.
  
    if (lj_list.length) {
      /**
       * to find the next target
       */
      try {
        var currentStep = this.getCurrentStep();
        var answers = {};
        (0, _classPrivateFieldGet2.default)(this, _user_steps).forEach(function (step) {
          var id = step.id,
              handle = step.settings.question.handle;
          var answerObj = (0, _classPrivateFieldGet2.default)(_this5, _user_answers)[id];
          if (!answerObj || !answerObj.answers) return;
          var answeredHandles = answerObj.answers.map(function (answer) {
            return answer.handle;
          });
          answers[handle] = answeredHandles;
        });
        var score = (0, _classPrivateFieldGet2.default)(this, _score) || 0;
  
        for (var i = 0; i < lj_list.length; i++) {
          var evaluator = _classPrivateMethodGet(this, _logicalJumpEvaluatorFactory, _logicalJumpEvaluatorFactory2).call(this, lj_list[i].target, lj_list[i].conditions_list);
  
          var candidateTarget = evaluator(answers, score);
          if (!candidateTarget) continue;
          target = candidateTarget;
          break;
        }
      } catch (e) {
        console.error("Couldn't evaluate logical jumps.", e);
      }
    } // If no logical jumps are found & the default target is valid, go to default target.
  
  
    if (target == "END" && _classPrivateMethodGet(this, _hasLogicalJumps, _hasLogicalJumps2).call(this, default_target)) target = default_target;
    return target;
  };
  
  var _isValidTarget2 = function _isValidTarget2(target) {
    return target && typeof target === "string" && target.trim() != "" && Array.isArray(this.all_steps) && this.all_steps.find(function (slide) {
      return slide.id == target;
    });
  };
  
  var _hasLogicalJumps2 = function _hasLogicalJumps2() {
    for (var key in (0, _classPrivateFieldGet2.default)(this, _all_jumps)) {
      var jump = (0, _classPrivateFieldGet2.default)(this, _all_jumps)[key];
      var lj_list = toolBox.getProp(jump, "list", []);
      if (lj_list.length) return true;
    }
  
    return false;
  };
  
  var _logicalJumpEvaluatorFactory2 = function _logicalJumpEvaluatorFactory2(target, conditionsList) {
    /** {"comparer": "answers", "qualifier": "includes", "context": "x3a_answer_handle_xxx", "value": "answer1"}  */
    var getExpression = function getExpression(condition) {
      var comparer = condition.comparer,
          qualifier = condition.qualifier,
          context = condition.context,
          value = condition.value;
      if (!comparer || !qualifier || !value || !(0, _typeof2.default)(comparer) === "string" || !(0, _typeof2.default)(qualifier) === "string") return "";
      var template = "";
  
      switch (qualifier.trim().toLowerCase()) {
        // exact match | applied directly on the answers array level.
        case 'is':
          qualifier = '==';
          template = '!!##left##.filter(leftValue => leftValue ##qualifier## ##right##).length';
          break;
        // partial match | applied to each value in the answers array individually
  
        case 'includes':
        case 'startsWith':
        case 'endsWith':
          template = '!!##left##.filter(leftValue => leftValue.##qualifier##(##right##)).length';
          break;
  
        case '!includes':
          qualifier = 'includes';
          template = '!##left##.some(leftValue => leftValue.##qualifier##(##right##))';
          break;
        // comparison | applied directly on the score
  
        case '==':
        case '=>':
        case '<=':
          template = '##left## ##qualifier## ##right##';
          break;
  
        default:
          break;
      }
  
      var right = isNaN(value) ? "'" + value + "'" : value;
      var left = comparer;
      if (context) left = "".concat(comparer, "['").concat(context, "']");
      return template.replace('##left##', left).replace('##right##', right).replace('##qualifier##', qualifier);
    }; // Build expression.
  
  
    var fullExpression = "";
    var orExpressions = [];
  
    for (var i = 0; i < conditionsList.length; i++) {
      var conditions = conditionsList[i];
      if (!conditions.length) continue;
      var andExpressions = [];
  
      for (var j = 0; j < conditions.length; j++) {
        var expression = getExpression(conditions[j]);
        if (!expression) continue;
        andExpressions.push(expression);
      }
  
      if (andExpressions.length) orExpressions.push("(".concat(andExpressions.join(' && '), ")"));
    }
  
    fullExpression = orExpressions.join(" || ");
    return new Function('answers', 'score', "\n      try {\n        console.log(answers, score);\n        if (!answers) answers = {};\n        if (!score) score = -1;\n\n        return ".concat(fullExpression, "? '").concat(target, "': null;\n      } catch (e) {\n        console.error(\"Couldn't evaluate logical jump conditions, \", e);\n      }\n    "));
  };
  
  var _sections = new WeakMap();
  
  var _sections_config = new WeakMap();
  
  var _section_instances = new WeakMap();
  
  var _clear = new WeakSet();
  
  var ResultsMaster = /*#__PURE__*/function () {
    function ResultsMaster() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        anchor_id: "app-quiz-results-anchor",
        modules: [],
        meta: {}
      };
      (0, _classCallCheck2.default)(this, ResultsMaster);
  
      _clear.add(this);
  
      _sections.set(this, {
        writable: true,
        value: {
          collection: _ResultCollection,
          cards: _ResultCards,
          hero: _ResultHero,
          script: _ResultScript,
          style: _ResultStyle
        }
      });
  
      _sections_config.set(this, {
        writable: true,
        value: {}
      });
  
      _section_instances.set(this, {
        writable: true,
        value: []
      });
  
      if (!options.anchor_id || !document.querySelector(options.anchor_id) || !options.modules || !options.modules.length || !options.meta || !options.meta.shop || !options.meta.id || !options.meta.v) return console.log("Couldn't initiate the ResultsMaster, missing arguments", arguments);
      this.root = document.querySelector(options.anchor_id);
      this.anchor_id = options.anchor_id;
      /***  process meta settings  ***/
  
      if (typeof Shopify != 'undefined') {
        this.shop_lang = Shopify.locale;
      }
  
      if (options.meta) {
        this.shop = options.meta.shop;
        this.quiz_id = options.meta.id;
        this.version = options.meta.v;
        this.page = options.meta.page;
      }
      /***  process quiz settings  ***/
  
  
      (0, _classPrivateFieldSet2.default)(this, _sections_config, options.modules);
      this.initSections();
      this.mountSections();
    }
  
    (0, _createClass2.default)(ResultsMaster, [{
      key: "initSections",
      value: function initSections() {
        var _iterator = _createForOfIteratorHelper((0, _classPrivateFieldGet2.default)(this, _sections_config)),
            _step2;
  
        try {
          for (_iterator.s(); !(_step2 = _iterator.n()).done;) {
            var section = _step2.value;
  
            try {
              var id = section.id,
                  type_id = section.type_id,
                  data = section.data;
              var instance = new ((0, _classPrivateFieldGet2.default)(this, _sections)[type_id])(this, _objectSpread(_objectSpread({}, section), {}, {
                shop: this.shop
              }));
              (0, _classPrivateFieldGet2.default)(this, _section_instances).push(instance);
            } catch (e) {
              console.error("Couldn't init result page section", e);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, {
      key: "reloadStep",
      value: function reloadStep(module_id, data) {
        var module = (0, _classPrivateFieldGet2.default)(this, _section_instances).find(function (m) {
          return m.id === module_id;
        });
        module.reloadStep(data);
      }
    }, {
      key: "remount",
      value: function remount(modules) {
        ResultsMaster.bind(this)({
          anchor_id: this.anchor_id,
          modules: modules,
          meta: {
            shop: this.shop,
            id: this.quiz_id,
            v: this.version,
            page: this.page
          }
        });
      }
    }, {
      key: "mountSections",
      value: function mountSections() {
        _classPrivateMethodGet(this, _clear, _clear2).call(this);
  
        var _iterator2 = _createForOfIteratorHelper((0, _classPrivateFieldGet2.default)(this, _section_instances)),
            _step3;
  
        try {
          for (_iterator2.s(); !(_step3 = _iterator2.n()).done;) {
            var instance = _step3.value;
            if (!this.shouldRender(instance.data.score_condition)) continue;
            var html = instance.getSectionHTML(instance, instance.data);
            var node = toolBox.htmlToElement(html);
            this.root.append(node);
            instance.isMounted();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }, {
      key: "shouldRender",
      value: function shouldRender(scoreConditions) {
        if (!window.QuizScore || !scoreConditions) return true;
        var canRender = true;
        scoreConditions.forEach(function (sc) {
          var condition = sc.condition,
              score = sc.score;
  
          switch (condition) {
            case '=':
              canRender = window.QuizScore == score;
              break;
  
            case '>':
              canRender = window.QuizScore > score;
              break;
  
            case '<':
              canRender = window.QuizScore < score;
              break;
  
            case '>=':
              canRender = window.QuizScore >= score;
              break;
  
            case '<=':
              canRender = window.QuizScore <= score;
              break;
  
            default:
              break;
          }
        });
        return canRender;
      }
    }]);
    return ResultsMaster;
  }(); // Initialization
  
  
  var _clear2 = function _clear2() {
    this.root.innerHTML = '';
  };
  
  window._QuizMaster = QuizMaster;
  window._ResultsMaster = ResultsMaster;
  window.quiz = {};
  window.quiz.instances = [];
  window.quiz.toolBox = toolBox;
  window.quizResults = {};
  window.quizResults.instances = [];
  window.quizResults.cache = {
    collections: {}
  };
  window.quizResults.toolBox = toolBox; // let quizPlaceholder = document.querySelector('[quiz-anchor-settings]');
  // let metaSettings = quizPlaceholder.getAttribute('quiz-anchor-settings');
  // let newQuizInstance = new window._QuizMaster({
  //   anchor_id: "#quiz-anchor", 
  //   configurations: quiz_data, 
  //   meta: {
  //     shop : "alfred-devstore-thomas.myshopify.com",
  //     id   : "quiz-v1",
  //     v    : "1",
  //     page : "quiz"
  //   }
  // })
  // window.quiz.instances.push(newQuizInstance);
  // const newResultsInstance = new window._ResultsMaster({
  //   anchor_id: "#quiz-results_anchor", 
  //   modules: [
  //     {
  //       id: '3j2bE4ja',
  //       type_id: 'hero',
  //       data: {
  //         title: 'Vos résultats',
  //         richtext: '<p>Lorem ipsum dolor sit amet</p>',
  //         img: {
  //           src: 'https://cdn.shopify.com/s/files/1/3000/3470/files/Homepage_1_1512x_51df5691-68f0-4a51-bd41-592480ddfa46.png?v=1603385155',
  //           alt: ''
  //         },
  //         styles: {
  //           backgroundColor: '#E1EDFB'
  //         }
  //       }
  //     },
  //     {
  //       id: '8y5hbeWe',
  //       type_id: 'collection',
  //       data: {
  //         title: 'Nos protéines',
  //         richtext: '<p>Lorem ipsum dolor sit amet</p>',
  //         direction: 'row',
  //         collection_handle: 'proteines',
  //         styles: {
  //           backgroundColor: '#1C1D20',
  //           color: 'white'
  //         }
  //       },
  //     },
  //     {
  //       id: '3j2bE4ja',
  //       type_id: 'hero',
  //       data: {
  //         title: 'Lore ipsum',
  //         richtext: '<p>Lorem ipsum dolor sit amet</p>',
  //         img: {
  //           src: 'https://cdn.shopify.com/s/files/1/3000/3470/files/Histoire_2.png?v=1603385155',
  //           alt: ''
  //         },
  //         styles: {
  //           backgroundColor: '#EEEEEF',
  //           direction: 'row-reverse'
  //         } 
  //       }
  //     },
  //   ],
  //   meta: {
  //     shop: "synergicnutrition.myshopify.com",
  //     id: "34ek9MEnWo",
  //     v: "1"
  //   }
  // })
  // window.quizResults.instances.push(newResultsInstance);
  //////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////// PLUGINS EXAMPLE.
  //////////////////////////////////////////////////////////////////////////////////////
  // window.__quizPlugins = {
  //   onResult : function () {
  //     // if implemented, it will override the main 
  //   },
  //   steps : [
  //     {
  //       class: 'question',
  //       subclass: 'email',
  //       onInit: function () {},
  //       getHTML: function () {
  //         return `<div id="${this.section_id}">Je suis la question</div>`;
  //       },
  //       onMount: function (selector) {
  //           console.log("input: ", arguments);
  //           console.log("This :", this);
  //           document.querySelector(selector).innerHTML = "New step"
  //       },
  //       onUnmount: function () {},
  //       onError: function () {
  //         var ERRORS = {
  //           REQUIRED: {
  //             fr: "Veuillez saisir votre email",
  //             en: "Please enter your email."
  //           },
  //           INVALID_EMAIL: {
  //             fr: "L'email saisi n'est pas valide.",
  //             en: "The entered email is not valid."
  //           }
  //         }
  //         var email = this.input.value;
  //         if (email.trim() == '')
  //           return this.updateErrorMessage(ERRORS.REQUIRED[this.lang || 'fr'])
  //         else
  //           return this.updateErrorMessage(ERRORS.INVALID_EMAIL[this.lang || 'fr'])
  //       },
  //       onSuccessfulSubmit: function () {
  //         var answer = this.root.querySelector('[data-answer]')
  //         answer.closest('[data-answer]').classList['add']("quiz__answer--selected")
  //         this.root.querySelector('[kqb-answers]').classList.add('quiz__answer--answered');
  //       }
  //     }
  //   ]
  // }
  //////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////// INITIATE THE QUIZ
  //////////////////////////////////////////////////////////////////////////////////////
  // let quiz = new window._QuizMaster({
  //   anchor_id: "app-quiz_anchor", 
  //   configurations: {}, 
  //   meta: {
  //     shop: "",
  //     id: "",
  //     v: ""
  //   }
  // })
  //////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////// INITIATE THE RESULTS
  //////////////////////////////////////////////////////////////////////////////////////
  // let results = new window._ResultsMaster({
  //   anchor_id: "app-results_anchor", 
  //   modules: [],
  //   meta: {
  //     shop: "",
  //     id: "",
  //     v: ""
  //   }
  // })
  //////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////// LOGICAL JUMPS EXAMPLE.
  //////////////////////////////////////////////////////////////////////////////////////
  // let logical_jump_ex = {
  //   "question_x":{
  //     "default_target":"question x+1",
  //     "list":[
  //       { // Logical jump possibility 1
  //         "target": "question y", 
  //         "conditions_list": [
  //           [ 
  //             {"comparer": "answers", "qualifier": "includes" , "value": "answer1"}
  //             , // AND
  //             {"comparer": "answers", "qualifier": "includes" , "value": "answer2"}
  //             , // AND
  //             {"comparer": "score",  "qualifier": ">"         , "value": "50"}
  //           ]
  //           , // OR
  //           [
  //             {"comparer": "answers", "qualifier": "includes" , "value": "answer1"}
  //             , // AND
  //             {"comparer": "answers", "qualifier": "includes" , "value": "answer2"}
  //             , // AND
  //             {"comparer": "score",  "qualifier": ">"         , "value": "60"}
  //           ]
  //         ]
  //       },
  //       { // Logical jump possibility 2
  //         "target": "question z",
  //         "conditions_list": [
  //           [ 
  //             {"comparer": "answers", "qualifier": "=="       , "value": "answer3"}
  //             , // AND
  //             {"comparer": "answers", "qualifier": "includes" , "value": "answer4"}
  //             , // AND
  //             {"comparer": "score",  "qualifier": ">="        , "value": "50"}
  //           ]
  //           , // OR
  //           [
  //             {"comparer": "answers", "qualifier": "=="       , "value": "answer5"}
  //             , // AND
  //             {"comparer": "answers", "qualifier": "includes" , "value": "answer6"}
  //             , // AND
  //             {"comparer": "score",  "qualifier": "=<"        , "value": "70"}
  //           ]
  //         ]
  //       }
  //     ]
  //   }
  // }
  // function logicalJumpEvaluatorFactory (target, conditionsList) {
  //   let getExpression = parts => {
  //     let functions = ['includes'];
  //     let structure = functions.find(func => parts.qualifier == func)? '##left##.##qualifier##(##right##)': '##left## ##qualifier## ##right##'
  //     let right = isNaN(parts.value)? "'" + parts.value + "'":parts.value;
  //     return structure.replace('##left##', parts.comparer).replace('##right##', right).replace('##qualifier##', parts.qualifier);
  //   }
  //   let expression = "";
  //   for (let i=0; i<conditionsList.length; i++) {
  //     let conditions = conditionsList[i];
  //     if (!conditions.length) continue;
  //     for (let j=0; j<conditions.length; j++) {
  //       let conditionParts = conditions[j];
  //       if (j == 0 && conditions.length > 1)
  //         expression += '( ';
  //       expression += getExpression(conditionParts);
  //       if (conditions.length > 1) {
  //         if (j < conditions.length - 1)
  //           expression += ' && ';
  //         else if (j == conditions.length - 1)
  //           expression += ' )';
  //       }
  //     }
  //     if (conditionsList.length > 1 && i < conditionsList.length - 1)
  //       expression += ' || ';
  //   }
  //   return new Function('name', 'age', `
  //     try {
  //       console.log(name, age);
  //       return ${expression}? '${target}': null;
  //     } catch (e) {
  //       console.error("Couldn't evaluate logical jump conditions, ", e);
  //     }
  //   `);
  // }
  // var x = logical_jump_ex.question_x.list[0];
  // var answers = ['answer1', 'answer2', 'answer3'];
  // var score = 60;
  // console.log(logicalJumpEvaluatorFactory(x.target, x.conditions_list)(answers, score));
  
  },{"./extendables/question":22,"./quiz_blocks/choices":25,"./quiz_blocks/date":26,"./quiz_blocks/email":27,"./quiz_blocks/number":28,"./quiz_blocks/range-slider":29,"./quiz_blocks/rating":30,"./quiz_blocks/single-choice":31,"./quiz_blocks/text":32,"./result_blocks/cards":33,"./result_blocks/collection":34,"./result_blocks/hero":35,"./result_blocks/script":36,"./result_blocks/style":37,"./tools/events":39,"./tools/general-helpers":40,"./tools/trackers":41,"@babel/runtime/helpers/asyncToGenerator":4,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/classPrivateFieldGet":6,"@babel/runtime/helpers/classPrivateFieldSet":7,"@babel/runtime/helpers/createClass":8,"@babel/runtime/helpers/defineProperty":9,"@babel/runtime/helpers/getPrototypeOf":10,"@babel/runtime/helpers/inherits":11,"@babel/runtime/helpers/interopRequireDefault":12,"@babel/runtime/helpers/possibleConstructorReturn":15,"@babel/runtime/helpers/typeof":18,"@babel/runtime/regenerator":20}],25:[function(require,module,exports){
  "use strict";
  
  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  
  var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
  
  var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
  
  var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
  
  var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
  
  var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
  
  var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
  
  var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
  
  var _classPrivateFieldGet2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldGet"));
  
  var _classPrivateFieldSet2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldSet"));
  
  var _ERRORS, _temp;
  
  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
  
  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
  
  var Question = require('../extendables/question');
  
  var toolBox = require('../tools/general-helpers');
  
  module.exports = (_temp = (_ERRORS = new WeakMap(), /*#__PURE__*/function (_Question) {
    (0, _inherits2.default)(_Choices, _Question);
  
    var _super = _createSuper(_Choices);
  
    // The template that should be used.
    function _Choices(quizManager, settings) {
      var _this;
  
      (0, _classCallCheck2.default)(this, _Choices);
      // Decide which template to use
      settings.question.answers_template = settings.question.min == 1 && settings.question.max == 1 ? "singlechoice" : "multichoice";
      _this = _super.call(this, quizManager, settings); // A choices question is invalid by default
  
      _ERRORS.set((0, _assertThisInitialized2.default)(_this), {
        writable: true,
        value: {}
      });
  
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "answers_template", null);
      _this.valid_answers = _this.required ? _this.required : true; // Set error messages
  
      (0, _classPrivateFieldSet2.default)((0, _assertThisInitialized2.default)(_this), _ERRORS, {
        REQUIRED: {
          fr: "Veuillez choisir une réponse",
          en: "Please choose an answer."
        },
        REQUIRED_MIN: {
          fr: "Veuillez choisir au minimum ".concat(settings.question.min, " r\xE9ponses"),
          en: "Please choose at least ".concat(settings.question.min, " answers")
        },
        REQUIRED_MAX: {
          fr: "Veuillez choisir au maximum ".concat(settings.question.max, " r\xE9ponses"),
          en: "Please choose a maximum of ".concat(settings.question.max, " answers")
        }
      });
      return _this;
    }
    /**************************************/
  
    /***************** INTERNAL HOOKS     */
  
    /**************************************/
  
  
    (0, _createClass2.default)(_Choices, [{
      key: "onMount",
      value: function onMount() {
        // attach specific event handlers main events
        this.root.querySelector('[kqb-answers]').addEventListener("change", function (e) {
          var checked_answers = this.root.querySelectorAll('[kqb-answers] input:checked');
          var answer_ids = [];
          (checked_answers || []).forEach(function (id) {
            answer_ids.push(id.closest("[data-answer]").getAttribute("data-answer-id"));
          });
          this.updateAnswer.bind(this)(answer_ids);
          if (checked_answers.length > this.settings.question.max) return this.onError();else this.updateErrorMessage(null);
          if (this.settings.question.min == 1 && this.settings.question.max == 1) this.autoSubmit();
        }.bind(this));
        this.root.querySelector('[kqb-answers]').addEventListener("quiz:custom-change", function (e) {
          var checked_answers = this.root.querySelectorAll('[kqb-answers] input:checked');
          var answer_ids = [];
          (checked_answers || []).forEach(function (id) {
            answer_ids.push(id.closest("[data-answer]").getAttribute("data-answer-id"));
          });
          this.updateAnswer.bind(this)(answer_ids);
          if (checked_answers.length > this.settings.question.max) return this.onError();else this.updateErrorMessage(null);
          if (this.settings.question.min == 1 && this.settings.question.max == 1) this.autoSubmit();
        }.bind(this));
        this.updateErrorMessage();
      }
    }, {
      key: "onSuccessfulSubmit",
      value: function onSuccessfulSubmit() {
        var answers = this.root.querySelectorAll('[data-answer]');
  
        for (var i = 0; i < answers.length; i++) {
          var checkedInput = answers[i].querySelector('input');
          var classAction = 'add';
          if (!checkedInput.checked) classAction = 'remove';
          checkedInput.closest('[data-answer]').classList[classAction]("quiz__answer--selected");
        }
  
        this.root.querySelector('[kqb-answers]').classList.add('quiz__answer--answered');

        this.root.querySelectorAll('[kqb-answers] input[type="radio"]:checked')?.forEach((input) => {
          // handler function
          var eventHandler = function(e) {
            // remove this handler
            e.target.removeEventListener('click', eventHandler, false);

            if (input.closest('[data-answer]').classList.contains('quiz__answer--selected')) {
              // Push event "change" to the parent element '[kqb-answers]'
              input.closest('[kqb-answers]')?.dispatchEvent(new Event("quiz:custom-change"));
            }
          }
          input.addEventListener("click", eventHandler);
        });
      }
    }, {
      key: "onError",
      value: function onError() {
        var message = "Something went wrong";
        var inputs = this.root.querySelectorAll('[kqb-answers] input:checked');
        if ((!inputs || inputs.length == 0) && this.required) message = (0, _classPrivateFieldGet2.default)(this, _ERRORS).REQUIRED[this.lang || 'fr'];else if (inputs.length > this.settings.question.max) message = (0, _classPrivateFieldGet2.default)(this, _ERRORS).REQUIRED_MAX[this.lang || 'fr'];else if (inputs.length < this.settings.question.min) message = (0, _classPrivateFieldGet2.default)(this, _ERRORS).REQUIRED_MIN[this.lang || 'fr'];
        return this.updateErrorMessage(message);
      }
      /**************************************/
  
      /***************** UTILITY FUNCTIONS  */
  
      /**************************************/
  
    }, {
      key: "updateAnswer",
      value: function updateAnswer(answer_ids) {
        var _this2 = this;
  
        this.settings.answers.forEach(function (answer) {
          if (answer_ids.includes(answer.id)) answer.result = true;else answer.result = false;
        });
        var questionId = this.settings.question.id;
        var answersObjects = this.settings.answers.filter(function (a) {
          return a.result;
        }).map(function (a, index) {
          return {
            content: a.content,
            handle: a.handle,
            metafields: a.metafields || {},
            score: _this2.settings.answers[index].score || 0
          };
        });
        this.submittable_data = {
          id: questionId,
          handle: toolBox.getProp(this, "settings.question.handle", "undefined"),
          question: toolBox.getProp(this, "settings.question.title", "undefined"),
          question_metafields: toolBox.getProp(this, "settings.question.metafields", {}),
          answers: answersObjects
        }; // TODO Moaaz
  
        var answersCount = this.settings.answers.filter(function (answer) {
          return answer.result;
        }).length;
        this.answered = !!answersCount;
        this.valid_answers = !answersCount && !this.required || answersCount >= this.settings.question.min && answersCount <= this.settings.question.max;
      }
    }]);
    return _Choices;
  }(Question)), _temp);
  
  },{"../extendables/question":22,"../tools/general-helpers":40,"@babel/runtime/helpers/assertThisInitialized":3,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/classPrivateFieldGet":6,"@babel/runtime/helpers/classPrivateFieldSet":7,"@babel/runtime/helpers/createClass":8,"@babel/runtime/helpers/defineProperty":9,"@babel/runtime/helpers/getPrototypeOf":10,"@babel/runtime/helpers/inherits":11,"@babel/runtime/helpers/interopRequireDefault":12,"@babel/runtime/helpers/possibleConstructorReturn":15}],26:[function(require,module,exports){
  "use strict";
  
  module.exports = {};
  
  },{}],27:[function(require,module,exports){
  "use strict";
  
  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  
  var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
  
  var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
  
  var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
  
  var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
  
  var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
  
  var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
  
  var _classPrivateFieldGet2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldGet"));
  
  var _ERRORS, _temp;
  
  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
  
  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
  
  var Question = require('../extendables/question');
  
  var toolBox = require('../tools/general-helpers');
  
  module.exports = (_temp = (_ERRORS = new WeakMap(), /*#__PURE__*/function (_Question) {
    (0, _inherits2.default)(_Email, _Question);
  
    var _super = _createSuper(_Email);
  
    function _Email() {
      var _this;
  
      (0, _classCallCheck2.default)(this, _Email);
  
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
  
      _this = _super.call.apply(_super, [this].concat(args));
  
      _ERRORS.set((0, _assertThisInitialized2.default)(_this), {
        writable: true,
        value: {
          REQUIRED_EMAIL: {
            fr: "Veuillez saisir votre email",
            en: "Please enter your email."
          },
          INVALID_EMAIL: {
            fr: "L'email saisi n'est pas valide.",
            en: "The entered email is not valid."
          },
          REQUIRED_PHONE: {
            fr: "Veuillez saisir votre téléphone",
            en: "Please enter your phone."
          },
          INVALID_PHONE: {
            fr: "Le téléphone saisi n'est pas valide.",
            en: "The entered phone is not valid."
          }
        }
      });
  
      return _this;
    }
  
    (0, _createClass2.default)(_Email, [{
      key: "onMount",
  
      /**************************************/
  
      /***************** INTERNAL HOOKS     */
  
      /**************************************/
      value: function onMount() {
        var _this2 = this;
  
        // Input mail
        this.inputMail = this.root.querySelector('#quiz_input_email[data-answer]') ? this.root.querySelector('#quiz_input_email[data-answer]') : '';
        this.inputMail.focus(); // attach specific event handlers main events

        // Input phone
        this.inputPhone = this.root.querySelector('#quiz_input_phone[data-answer]') ? this.root.querySelector('#quiz_input_phone[data-answer]') : '';

        // Input accepts email and sms (checkbox)
        this.inputAcceptsEmail = this.root.querySelector('#quiz-accepts-email[data-answer]') ? this.root.querySelector('#quiz-accepts-email[data-answer]') : '';
        this.inputAcceptsSms = this.root.querySelector('#quiz-accepts-sms[data-answer]') ? this.root.querySelector('#quiz-accepts-sms[data-answer]') : '';
        if (this.inputAcceptsEmail && this.inputAcceptsEmail != '') {
          this.inputAcceptsEmail.addEventListener('change', () => {
            const acceptsEmail = this.inputAcceptsEmail?.checked;
            const acceptsSms = this.inputAcceptsSms?.checked;
            this.updateAnswer.bind(this)(this.inputMail.value.trim(), this.inputPhone.value.trim(), acceptsEmail, acceptsSms);
          });
        }
        if (this.inputAcceptsSms && this.inputAcceptsSms != '') {
          this.inputAcceptsSms.addEventListener('change', () => {
            const acceptsEmail = this.inputAcceptsEmail?.checked;
            const acceptsSms = this.inputAcceptsSms?.checked;
            this.updateAnswer.bind(this)(this.inputMail.value.trim(), this.inputPhone.value.trim(), acceptsEmail, acceptsSms);
          });
        }
  
        // Events listener
        const answers = this.root.querySelectorAll('#quiz_input_email[data-answer], #quiz_input_phone[data-answer]');
        if (answers.length > 0) {
          answers.forEach(answer => {
            answer.addEventListener("input", function (e) {
              return _this2.keydown(e.data)?.bind(_this2);
            });
            answer.addEventListener("keydown", function (e) {
              return e.key == "Enter" ? _this2.keydown(e.key).bind(_this2) : function () {};
            });
          });
        }
      }
    }, {
      key: "onError",
      value: function onError() {

        function validateEmail(email) {
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(String(email).toLowerCase());
        }

        function validatePhone(phone) {
          const phoneFormated = phone.replaceAll(' ', '');
          const isInternationalPhone = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(phoneFormated);
          return isInternationalPhone;
        }
  
        if (this.inputMail && this.inputMail != '') {
          var email = this.inputMail.value;
          let emailIsRequired = false;
          if (this.inputMail.hasAttribute('required')) {
            emailIsRequired = true;
          }
          if (emailIsRequired && email.trim() == '') return this.onErrorMail();
          if (email !== null && email !== '') {
            var isValidEmail = validateEmail(email);
            if (stroke != undefined && stroke == "Enter" && !isValidEmail) {
              return this.onErrorMail();
            } else if (!isValidEmail) {
              this.answered = false;
              this.submittable_data = {};
              return;
            }
          }
        }

        if (this.inputPhone && this.inputPhone != '') {
          var phone = this.inputPhone.value;
          let phoneIsRequired = false;
          if (this.inputPhone.hasAttribute('required')) {
            phoneIsRequired = true;
          }
          if (phoneIsRequired && phone.trim() == '') return this.onErrorPhone();
          if (phone !== null && phone !== '') {
            var isValidPhone = validatePhone(phone);
            if (stroke == "Enter" && !isValidPhone) {
              return this.onErrorPhone();
            } else if (!isValidPhone) {
              this.answered = false;
              this.submittable_data = {};
              return;
            }
          }
        }
      }
    }, {
      key: "onErrorMail",
      value: function onErrorMail() {
        var email = this.inputMail.value;
        let emailIsRequired = false;
        if (this.inputMail.hasAttribute('required')) {
          emailIsRequired = true;
        }
        if (emailIsRequired && email.trim() == '') {
          return this.updateErrorMessage((0, _classPrivateFieldGet2.default)(this, _ERRORS).REQUIRED_EMAIL[this.lang || 'fr']);
        } else {
          return this.updateErrorMessage((0, _classPrivateFieldGet2.default)(this, _ERRORS).INVALID_EMAIL[this.lang || 'fr']);
        }
      }
    }, {
      key: "onErrorPhone",
      value: function onErrorPhone() {
        var phone = this.inputPhone.value;
        let phoneIsRequired = false;
        if (this.inputPhone.hasAttribute('required')) {
          phoneIsRequired = true;
        }
        if (phoneIsRequired && phone.trim() == '') {
          return this.updateErrorMessage((0, _classPrivateFieldGet2.default)(this, _ERRORS).REQUIRED_PHONE[this.lang || 'fr']);
        } else {
          return this.updateErrorMessage((0, _classPrivateFieldGet2.default)(this, _ERRORS).INVALID_PHONE[this.lang || 'fr']);
        }
      }
    }, {
      key: "onSuccessfulSubmit",
      value: function onSuccessfulSubmit() {
        var answer = this.root.querySelector('[data-answer]');
        answer.closest('[data-answer]').classList['add']("quiz__answer--selected");
        this.root.querySelector('[kqb-answers]').classList.add('quiz__answer--answered');
      }
      /**************************************/
  
      /***************** UTILITY FUNCTIONS  */
  
      /**************************************/
  
    }, {
      key: "keydown",
      value: function keydown(stroke) {

        function validateEmail(email) {
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(String(email).toLowerCase());
        }

        function validatePhone(phone) {
          const phoneFormated = phone.replaceAll(' ', '');
          const isInternationalPhone = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(phoneFormated);
          return isInternationalPhone;
        }
  
        var email = this.inputMail ? this.inputMail.value : '';
        if (this.inputMail && this.inputMail != '') {
          let emailIsRequired = false;
          if (this.inputMail.hasAttribute('required')) {
            emailIsRequired = true;
          }
          if (emailIsRequired && email.trim() == '') return;
          if (email !== null && email !== '') {
            var isValidEmail = validateEmail(email);
            if (stroke == "Enter" && !isValidEmail) {
              return this.onErrorMail();
            } else if (!isValidEmail) {
              this.answered = false;
              this.submittable_data = {};
              return;
            }
          }
        }

        var phone = this.inputPhone ? this.inputPhone.value : '';
        if (this.inputPhone && this.inputPhone != '') {
          let phoneIsRequired = false;
          if (this.inputPhone.hasAttribute('required')) {
            phoneIsRequired = true;
          }
          if (phoneIsRequired && phone.trim() == '') return;
          if (phone !== null && phone !== '') {
            var isValidPhone = validatePhone(phone);
            if (stroke == "Enter" && !isValidPhone) {
              return this.onErrorPhone();
            } else if (!isValidPhone) {
              this.answered = false;
              this.submittable_data = {};
              return;
            }
          }
        }

        // TODO: Update specifics to this project
        const acceptsEmail = this.inputAcceptsEmail?.checked;
        const acceptsSms = this.inputAcceptsSms?.checked;
        this.updateAnswer.bind(this)(email.trim(), phone.trim(), acceptsEmail, acceptsSms);
        if (stroke == "Enter") return this.submit();

      }
    }, {
      key: "updateAnswer",
      value: function updateAnswer(email, phone, acceptsEmail, acceptsSms) {
        var questionId = this.settings.question.id;
        this.submittable_data = {
          id: questionId,
          handle: toolBox.getProp(this, "settings.question.handle", "undefined"),
          question: toolBox.getProp(this, "settings.question.title", "undefined"),
          question_metafields: toolBox.getProp(this, "settings.question.metafields", {}),
          answers: [{
            content: `${email}|${phone}|${acceptsEmail ? 'yes' : 'no'}|${acceptsSms ? 'yes' : 'no'}`,
            handle: toolBox.getProp(this, "settings.question.handle", "undefined") + '-answer',
            score: toolBox.getProp(this, "settings.question.score", 0)
          }]
        };
        this.answered = true;
      }
    }]);
    return _Email;
  }(Question)), _temp);
  
  },{"../extendables/question":22,"../tools/general-helpers":40,"@babel/runtime/helpers/assertThisInitialized":3,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/classPrivateFieldGet":6,"@babel/runtime/helpers/createClass":8,"@babel/runtime/helpers/getPrototypeOf":10,"@babel/runtime/helpers/inherits":11,"@babel/runtime/helpers/interopRequireDefault":12,"@babel/runtime/helpers/possibleConstructorReturn":15}],28:[function(require,module,exports){
  "use strict";
  
  module.exports = {};
  
  },{}],29:[function(require,module,exports){
  "use strict";
  
  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  
  var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
  
  var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
  
  var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
  
  var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
  
  var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
  
  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
  
  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
  
  var Question = require('./../extendables/question.js');
  
  var toolBox = require('./../tools/general-helpers.js');
  
  module.exports = /*#__PURE__*/function (_Question) {
    (0, _inherits2.default)(_RangeSlider, _Question);
  
    var _super = _createSuper(_RangeSlider);
  
    function _RangeSlider(quizManager, settings) {
      var _this;
  
      (0, _classCallCheck2.default)(this, _RangeSlider);
      _this = _super.call(this, quizManager, settings);
      _this.prefix = settings.question.prefix && typeof settings.question.prefix === 'string' && settings.question.prefix.trim() != "" ? settings.question.prefix : "";
      _this.postfix = settings.question.postfix && typeof settings.question.postfix === 'string' && settings.question.postfix.trim() != "" ? settings.question.postfix : "";
      _this.min = settings.question.min;
      _this.max = settings.question.max;
      _this.step = settings.question.step;
      _this.default = parseInt(settings.question.default);
      return _this;
    }
    /**************************************/
  
    /***************** INTERNAL HOOKS     */
  
    /**************************************/
  
  
    (0, _createClass2.default)(_RangeSlider, [{
      key: "onMount",
      value: function onMount() {
        // Assign elements as variables.
        this.sliderInput = this.root.querySelector('[data-answer]');
        this.ticksContainer = this.root.querySelector('.quiz__answer__ticks');
        this.displayedValue = this.root.querySelector('.quiz__answer__value span');
  
        var ticksCount = (this.max - this.min) / this.step + 1;
  
        for (var i = 0; i < ticksCount; i++) {
          var ele = document.createElement("span");
          ele.classList.add('tick');
          this.ticksContainer.appendChild(ele);
        }
  
        this.ticks = this.ticksContainer.getElementsByClassName("tick"); // Set the value to the default value.
  
        this.sliderInput.value = this.default; // update displayed value.
  
        this.change(); // Handle value change
        // Ref: https://stackoverflow.com/a/37623959/2517028
  
        function onRangeChange(ele, handler) {
          var n, c, m;
          ele.addEventListener("input", function (e) {
            n = 1;
            c = e.target.value;
            if (c != m) handler(e);
            m = c;
          });
          ele.addEventListener("change", function (e) {
            if (!n) handler(e);
          });
        }
  
        onRangeChange(this.sliderInput, this.change.bind(this));
      }
    }, {
      key: "onError",
      value: function onError() {
        console.log("Error handling not required");
      }
    }, {
      key: "onSuccessfulSubmit",
      value: function onSuccessfulSubmit() {
        var answer = this.root.querySelector('[data-answer]');
        answer.closest('[data-answer]').classList['add']("quiz__answer--selected");
        this.root.querySelector('[kqb-answers]').classList.add('quiz__answer--answered');
      }
      /**************************************/
  
      /***************** UTILITY FUNCTIONS  */
  
      /**************************************/
  
    }, {
      key: "change",
      value: function change(e) {
        // update displayed value.
        this.updateRangeElement(); // update answer
  
        return this.updateAnswer.bind(this)();
      }
    }, {
      key: "updateRangeElement",
      value: function updateRangeElement(value) {
        var range = this.sliderInput;
        var value = parseInt(range.value); // Update ticks
  
        var currentTick = (value - parseInt(range.min)) / parseInt(range.step);
  
        for (var i = 0; i < this.ticks.length; i++) {
          var tick = this.ticks[i];
          tick.classList.remove('tick--active');
          if (currentTick >= i) tick.classList.add('tick--active');
        } // Update displayed value
  
  
        var displayableValue = "".concat(this.prefix).concat(value).concat(this.postfix);
        var leftPercent = "".concat((value - this.min) / (this.max - this.min) * 100);
        var displayableValue = "".concat(this.prefix).concat(value).concat(this.postfix);
        this.displayedValue.innerHTML = displayableValue;
        /* TOD: Moaaz update rangeBar */
  
        this.displayedValue.style.left = leftPercent + "%";
        if (leftPercent <= 5) this.displayedValue.style.transform = "unset";else if (leftPercent >= 95) {
          this.displayedValue.style.right = "0";
          this.displayedValue.style.left = "unset";
          this.displayedValue.style.transform = "unset";
        } else {
          this.displayedValue.style.right = "unset";
          this.displayedValue.style.transform = "translate(-50%)";
        }
      }
    }, {
      key: "updateAnswer",
      value: function updateAnswer(value) {
        var value = parseInt(this.sliderInput.value);
        var questionId = this.settings.question.id;
        this.submittable_data = {
          id: questionId,
          handle: toolBox.getProp(this, "settings.question.handle", "undefined"),
          question: toolBox.getProp(this, "settings.question.title", "undefined"),
          question_metafields: toolBox.getProp(this, "settings.question.metafields", {}),
          answers: [{
            content: value,
            handle: toolBox.getProp(this, "settings.question.handle", "undefined") + '-answer',
            score: toolBox.getProp(this, "settings.question.score", 0)
          }]
        };
        this.answered = true;
      }
    }]);
    return _RangeSlider;
  }(Question);
  
  },{"./../extendables/question.js":22,"./../tools/general-helpers.js":40,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":8,"@babel/runtime/helpers/getPrototypeOf":10,"@babel/runtime/helpers/inherits":11,"@babel/runtime/helpers/interopRequireDefault":12,"@babel/runtime/helpers/possibleConstructorReturn":15}],30:[function(require,module,exports){
  "use strict";
  
  module.exports = {};
  
  },{}],31:[function(require,module,exports){
  "use strict";
  
  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  
  var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
  
  var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
  
  var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
  
  var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
  
  var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
  
  var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
  
  var _classPrivateFieldGet2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldGet"));
  
  var _ERRORS, _temp;
  
  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
  
  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
  
  var Question = require('./../extendables/question.js');
  
  var toolBox = require('./../tools/general-helpers.js');
  
  module.exports = (_temp = (_ERRORS = new WeakMap(), /*#__PURE__*/function (_Question) {
    (0, _inherits2.default)(_SingleChoice, _Question);
  
    var _super = _createSuper(_SingleChoice);
  
    function _SingleChoice() {
      var _this;
  
      (0, _classCallCheck2.default)(this, _SingleChoice);
  
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
  
      _this = _super.call.apply(_super, [this].concat(args));
  
      _ERRORS.set((0, _assertThisInitialized2.default)(_this), {
        writable: true,
        value: {
          SINGLE_CHOICE_REQUIRED: {
            fr: "Sélectionnez une réponse",
            en: "Select an answer"
          }
        }
      });
  
      return _this;
    }
  
    (0, _createClass2.default)(_SingleChoice, [{
      key: "onMount",
  
      /**************************************/
  
      /***************** INTERNAL HOOKS     */
  
      /**************************************/
      value: function onMount() {
        // attach specific event handlers main events
        var answers = this.root.querySelectorAll('[data-answers] input');
  
        for (var i = 0; i < answers.length; i++) {
          answers[i].addEventListener("change", function (e) {
            if (!e.target) return;
            var answer = e.target.closest("[data-question]").querySelector('[data-answer] input[type="radio"]:checked');
            if (!answer) return this.onError((0, _classPrivateFieldGet2.default)(this, _ERRORS).SINGLE_CHOICE_REQUIRED);
            var answer_id = answer.closest("[data-answer]").getAttribute("data-answer-id");
            if (!answer_id) return this.onError((0, _classPrivateFieldGet2.default)(this, _ERRORS).SINGLE_CHOICE_REQUIRED);
            this.updateAnswer.bind(this)(answer_id);
            this.autoSubmit();
          }.bind(this));
        }
      }
    }, {
      key: "onSuccessfulSubmit",
      value: function onSuccessfulSubmit() {
        var answers = this.root.querySelectorAll('[data-answer]');
  
        for (var i = 0; i < answers.length; i++) {
          var checkedInput = answers[i].querySelector('input[type="radio"]');
          var classAction = 'add';
          if (!checkedInput.checked) classAction = 'remove';
          checkedInput.closest('[data-answer]').classList[classAction]("quiz__answer--selected");
        }
  
        this.root.querySelector('[kqb-answers]').classList.add('quiz__answer--answered');
      }
    }, {
      key: "onError",
      value: function onError() {
        return this.updateErrorMessage((0, _classPrivateFieldGet2.default)(this, _ERRORS).SINGLE_CHOICE_REQUIRED[this.lang || 'fr']);
      }
      /**************************************/
  
      /***************** UTILITY FUNCTIONS  */
  
      /**************************************/
  
    }, {
      key: "updateAnswer",
      value: function updateAnswer(answer_id) {
        this.settings.answers.forEach(function (answer) {
          if (answer.id != answer_id) answer.result = false;else answer.result = true;
        });
        var questionId = this.settings.question.id;
        var answerObj = this.settings.answers.find(function (a) {
          return a.result;
        });
        this.submittable_data = {
          id: questionId,
          handle: toolBox.getProp(this, "settings.question.handle", "undefined"),
          question: toolBox.getProp(this, "settings.question.title", "undefined"),
          question_metafields: toolBox.getProp(this, "settings.question.metafields", {}),
          answers: [{
            content: answerObj.content,
            handle: answerObj.handle,
            metafields: answerObj.metafields || {}
          }]
        }; // TODO Moaaz
  
        this.answered = this.settings.answers.find(function (answer) {
          return answer.result;
        }) ? true : false;
      }
    }]);
    return _SingleChoice;
  }(Question)), _temp);
  
  },{"./../extendables/question.js":22,"./../tools/general-helpers.js":40,"@babel/runtime/helpers/assertThisInitialized":3,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/classPrivateFieldGet":6,"@babel/runtime/helpers/createClass":8,"@babel/runtime/helpers/getPrototypeOf":10,"@babel/runtime/helpers/inherits":11,"@babel/runtime/helpers/interopRequireDefault":12,"@babel/runtime/helpers/possibleConstructorReturn":15}],32:[function(require,module,exports){
  "use strict";
  
  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  
  var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
  
  var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
  
  var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
  
  var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
  
  var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
  
  var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
  
  var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
  
  var _classPrivateFieldGet2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldGet"));
  
  var _classPrivateFieldSet2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldSet"));
  
  var _ERRORS, _temp;
  
  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
  
  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
  
  var Question = require('../extendables/question');
  
  var toolBox = require('../tools/general-helpers');
  
  module.exports = (_temp = (_ERRORS = new WeakMap(), /*#__PURE__*/function (_Question) {
    (0, _inherits2.default)(_Text, _Question);
  
    var _super = _createSuper(_Text);
  
    function _Text(quizManager, settings) {
      var _this;
  
      (0, _classCallCheck2.default)(this, _Text);
      _this = _super.call(this, quizManager, settings);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "SOFT_MAX_CHARS_LIMIT", 1000);
  
      _ERRORS.set((0, _assertThisInitialized2.default)(_this), {
        writable: true,
        value: {}
      });
  
      var _this$settings$questi = _this.settings.question,
          min = _this$settings$questi.min,
          max = _this$settings$questi.max;
      min = parseInt(min);
      max = parseInt(max);
      _this.min = min && typeof min == 'number' && min >= 0 ? min : 0;
      _this.min = _this.min > _this.SOFT_MAX_CHARS_LIMIT ? _this.SOFT_MAX_CHARS_LIMIT - 1 : _this.min;
      _this.max = max && typeof max == 'number' && max >= _this.min ? max : _this.SOFT_MAX_CHARS_LIMIT; // Set error messages
  
      (0, _classPrivateFieldSet2.default)((0, _assertThisInitialized2.default)(_this), _ERRORS, {
        REQUIRED: {
          fr: "Veuillez saisir une réponse",
          en: "Please enter an answer."
        },
        EQUALS: {
          fr: "Veuillez saisir une r\xE9ponse avec nombre de caracteres egale \xE0 ".concat(_this.min),
          en: "Accepted answer length is exactly ".concat(_this.min, " chars")
        },
        MIN: {
          fr: "Veuillez saisir une r\xE9ponse avec nombre de caracteres sup\xE9rieur \xE0 ".concat(_this.min),
          en: "Accepted answer length is min ".concat(_this.min, " chars")
        },
        MAX: {
          fr: "Veuillez saisir une r\xE9ponse avec nombre de caracteres inferieur \xE0 ".concat(_this.max),
          en: "Accepted answer length is max ".concat(_this.max, " chars")
        },
        UNKNOWN: {
          fr: "Veuillez saisir une r\xE9ponse valide",
          en: "Please enter a valid value"
        }
      });
      return _this;
    }
    /**************************************/
  
    /***************** INTERNAL HOOKS     */
  
    /**************************************/
  
  
    (0, _createClass2.default)(_Text, [{
      key: "onMount",
      value: function onMount() {
        var _this2 = this;
  
        this.input = this.root.querySelector('[data-answer]');
        this.input.focus(); // attach specific event handlers main events
  
        this.root.querySelector('[data-answer]').addEventListener("input", this.keydown.bind(this));
        this.root.querySelector('[data-answer]').addEventListener("keydown", function (e) {
          return e.key == "Enter" ? _this2.keydown(e.key) : function () {};
        });
      }
    }, {
      key: "onSuccessfulSubmit",
      value: function onSuccessfulSubmit() {
        var answer = this.root.querySelector('[data-answer]');
        answer.closest('[data-answer]').classList['add']("quiz__answer--selected");
        this.root.querySelector('[kqb-answers]').classList.add('quiz__answer--answered');
      }
    }, {
      key: "onError",
      value: function onError() {
        var answer = this.input.value;
        if (this.required && answer.trim() == '' || typeof answer != 'string') return this.updateErrorMessage((0, _classPrivateFieldGet2.default)(this, _ERRORS).REQUIRED[this.lang || 'fr']);else if (this.max == this.min && answer.length != this.min) return this.updateErrorMessage((0, _classPrivateFieldGet2.default)(this, _ERRORS).EQUALS[this.lang || 'fr']);else if (answer.length < this.min) return this.updateErrorMessage((0, _classPrivateFieldGet2.default)(this, _ERRORS).MIN[this.lang || 'fr']);else return this.updateErrorMessage((0, _classPrivateFieldGet2.default)(this, _ERRORS).UNKNOWN[this.lang || 'fr']);
      }
      /**************************************/
  
      /***************** UTILITY FUNCTIONS  */
  
      /**************************************/
  
    }, {
      key: "keydown",
      value: function keydown(stroke) {
        var isValidAnswer = function (answer) {
          if (this.required && answer.trim() == '' || typeof answer != 'string') return false;else if (this.max == this.min && answer.length != this.min) return false;else if (answer.length < this.min) return false;
          return true;
        }.bind(this);
  
        var answer = this.input.value;
        this.input.value = answer.substring(0, this.max);
        var isValid = isValidAnswer(answer);
        if (!isValid) return this.onError();
        this.updateAnswer.bind(this)(answer);
        if (stroke == "Enter") return this.submit();
      }
    }, {
      key: "updateAnswer",
      value: function updateAnswer(answer) {
        var questionId = this.settings.question.id;
        this.submittable_data = {
          id: questionId,
          handle: toolBox.getProp(this, "settings.question.handle", "undefined"),
          question: toolBox.getProp(this, "settings.question.title", "undefined"),
          question_metafields: toolBox.getProp(this, "settings.question.metafields", {}),
          answers: [{
            content: answer,
            handle: toolBox.getProp(this, "settings.question.handle", "undefined") + '-answer',
            score: toolBox.getProp(this, "settings.question.score", 0)
          }]
        };
        this.answered = true;
      }
    }]);
    return _Text;
  }(Question)), _temp);
  
  },{"../extendables/question":22,"../tools/general-helpers":40,"@babel/runtime/helpers/assertThisInitialized":3,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/classPrivateFieldGet":6,"@babel/runtime/helpers/classPrivateFieldSet":7,"@babel/runtime/helpers/createClass":8,"@babel/runtime/helpers/defineProperty":9,"@babel/runtime/helpers/getPrototypeOf":10,"@babel/runtime/helpers/inherits":11,"@babel/runtime/helpers/interopRequireDefault":12,"@babel/runtime/helpers/possibleConstructorReturn":15}],33:[function(require,module,exports){
  "use strict";
  
  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  
  var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
  
  var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
  
  var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
  
  var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
  
  var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
  
  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
  
  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
  
  var ResultSection = require('../extendables/result_section');
  
  module.exports = /*#__PURE__*/function (_ResultSection) {
    (0, _inherits2.default)(_Cards, _ResultSection);
  
    var _super = _createSuper(_Cards);
  
    function _Cards() {
      (0, _classCallCheck2.default)(this, _Cards);
      return _super.apply(this, arguments);
    }
  
    (0, _createClass2.default)(_Cards, [{
      key: "onMount",
  
      /**************************************/
  
      /***************** INTERNAL HOOKS     */
  
      /**************************************/
      value: function onMount() {// const moduleEl = document.querySelector(`[amdl-${this.id}]`);
      }
    }]);
    return _Cards;
  }(ResultSection);
  
  },{"../extendables/result_section":23,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":8,"@babel/runtime/helpers/getPrototypeOf":10,"@babel/runtime/helpers/inherits":11,"@babel/runtime/helpers/interopRequireDefault":12,"@babel/runtime/helpers/possibleConstructorReturn":15}],34:[function(require,module,exports){
  "use strict";
  
  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  
  var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
  
  var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
  
  var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
  
  var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
  
  var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
  
  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
  
  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
  
  var ResultSection = require('../extendables/result_section');
  
  var toolBox = require('../tools/general-helpers');
  
  module.exports = /*#__PURE__*/function (_ResultSection) {
    (0, _inherits2.default)(_Collection, _ResultSection);
  
    var _super = _createSuper(_Collection);
  
    function _Collection() {
      (0, _classCallCheck2.default)(this, _Collection);
      return _super.apply(this, arguments);
    }
  
    (0, _createClass2.default)(_Collection, [{
      key: "onMount",
  
      /**************************************/
  
      /***************** INTERNAL HOOKS     */
  
      /**************************************/
      value: function onMount() {
        var data = this.data || {};
        var shop = this.shop;
        var root = this.root;
        var collectionHandle = data.collection_handle;
        var moduleEl = root.querySelector('[amdl-collection]');
        var collectionProductsEl = moduleEl.querySelector('[amdl-collection__products]');
  
        function appendProduct(product) {
          var template = toolBox.renderTemplate("result_section_collection_product", {
            img: product.images[0] || {},
            shop: shop,
            product: product
          });
          collectionProductsEl.appendChild(toolBox.htmlToElement(template));
        }
  
        function initiaizeCollectionProducts() {
          if (window.quizResults.cache.collections[collectionHandle]) {
            window.quizResults.cache.collections[collectionHandle].forEach(function (product) {
              appendProduct(product, shop);
            });
            return;
          }
  
          var xhr = new XMLHttpRequest();
          var url = "https://".concat(shop, "/collections/").concat(collectionHandle, "/products.json");
          xhr.open('GET', url, true);
          xhr.send();
  
          xhr.onload = function () {
            if (xhr.status !== 200) return;
            var response = JSON.parse(xhr.response);
            response.products.forEach(function (product) {
              appendProduct(product, shop);
            });
            window.quizResults.cache.collections[collectionHandle] = response.products;
          };
        }
  
        initiaizeCollectionProducts(); // if (`${data.direction}`.includes("row"))
        //   new Flickity(`[amdl-${this.id}] [amdl-collection__products]`, {});
      }
    }]);
    return _Collection;
  }(ResultSection);
  
  },{"../extendables/result_section":23,"../tools/general-helpers":40,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":8,"@babel/runtime/helpers/getPrototypeOf":10,"@babel/runtime/helpers/inherits":11,"@babel/runtime/helpers/interopRequireDefault":12,"@babel/runtime/helpers/possibleConstructorReturn":15}],35:[function(require,module,exports){
  "use strict";
  
  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  
  var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
  
  var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
  
  var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
  
  var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
  
  var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
  
  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
  
  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
  
  var ResultSection = require('../extendables/result_section');
  
  module.exports = /*#__PURE__*/function (_ResultSection) {
    (0, _inherits2.default)(_Hero, _ResultSection);
  
    var _super = _createSuper(_Hero);
  
    function _Hero() {
      (0, _classCallCheck2.default)(this, _Hero);
      return _super.apply(this, arguments);
    }
  
    (0, _createClass2.default)(_Hero, [{
      key: "onMount",
  
      /**************************************/
  
      /***************** INTERNAL HOOKS     */
  
      /**************************************/
      value: function onMount() {// const moduleEl = document.querySelector(`[amdl-${this.id}]`);
      }
    }]);
    return _Hero;
  }(ResultSection);
  
  },{"../extendables/result_section":23,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":8,"@babel/runtime/helpers/getPrototypeOf":10,"@babel/runtime/helpers/inherits":11,"@babel/runtime/helpers/interopRequireDefault":12,"@babel/runtime/helpers/possibleConstructorReturn":15}],36:[function(require,module,exports){
  "use strict";
  
  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  
  var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
  
  var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
  
  var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
  
  var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
  
  var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
  
  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
  
  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
  
  var ResultSection = require('../extendables/result_section');
  
  module.exports = /*#__PURE__*/function (_ResultSection) {
    (0, _inherits2.default)(_Script, _ResultSection);
  
    var _super = _createSuper(_Script);
  
    function _Script() {
      (0, _classCallCheck2.default)(this, _Script);
      return _super.apply(this, arguments);
    }
  
    (0, _createClass2.default)(_Script, [{
      key: "onMount",
  
      /**************************************/
  
      /***************** INTERNAL HOOKS     */
  
      /**************************************/
      value: function onMount() {// const module = document.querySelector(`[amdl-${this.id}]`);
      }
    }]);
    return _Script;
  }(ResultSection);
  
  },{"../extendables/result_section":23,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":8,"@babel/runtime/helpers/getPrototypeOf":10,"@babel/runtime/helpers/inherits":11,"@babel/runtime/helpers/interopRequireDefault":12,"@babel/runtime/helpers/possibleConstructorReturn":15}],37:[function(require,module,exports){
  "use strict";
  
  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  
  var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
  
  var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
  
  var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
  
  var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
  
  var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
  
  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
  
  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
  
  var ResultSection = require('../extendables/result_section');
  
  module.exports = /*#__PURE__*/function (_ResultSection) {
    (0, _inherits2.default)(_Style, _ResultSection);
  
    var _super = _createSuper(_Style);
  
    function _Style() {
      (0, _classCallCheck2.default)(this, _Style);
      return _super.apply(this, arguments);
    }
  
    (0, _createClass2.default)(_Style, [{
      key: "onMount",
  
      /**************************************/
  
      /***************** INTERNAL HOOKS     */
  
      /**************************************/
      value: function onMount() {// const module = document.querySelector('[amdl-${this.id}]`);
      }
    }]);
    return _Style;
  }(ResultSection);
  
  },{"../extendables/result_section":23,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":8,"@babel/runtime/helpers/getPrototypeOf":10,"@babel/runtime/helpers/inherits":11,"@babel/runtime/helpers/interopRequireDefault":12,"@babel/runtime/helpers/possibleConstructorReturn":15}],38:[function(require,module,exports){
  "use strict"; // doT.js
  // 2011-2014, Laura Doktorova, https://github.com/olado/doT
  // Licensed under the MIT license.
  
  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  
  var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
  
  var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
  
  var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
  
  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
  
  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
  
  module.exports = {
    template: template,
    compile: compile,
    setDelimiters: setDelimiters
  };
  var templateSettings = {
    argName: "it",
    encoders: {},
    selfContained: false,
    strip: true,
    internalPrefix: "_val",
    encodersPrefix: "_enc",
    delimiters: {
      start: "{{",
      end: "}}"
    }
  }; // depends on selfContained mode
  
  var encoderType = {
    false: "function",
    true: "string"
  };
  var defaultSyntax = {
    evaluate: /\{\{([\s\S]+?(\}?)+)\}\}/g,
    interpolate: /\{\{=([\s\S]+?)\}\}/g,
    typeInterpolate: /\{\{%([nsb])=([\s\S]+?)\}\}/g,
    encode: /\{\{([a-z_$]+[\w$]*)?!([\s\S]+?)\}\}/g,
    use: /\{\{#([\s\S]+?)\}\}/g,
    useParams: /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$]+(?:\.[\w$]+|\[[^\]]+\])*|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\}|\[[^\]]*\])/g,
    define: /\{\{##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,
    defineParams: /^\s*([\w$]+):([\s\S]+)/,
    conditional: /\{\{\?(\?)?\s*([\s\S]*?)\s*\}\}/g,
    iterate: /\{\{~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g
  };
  
  var currentSyntax = _objectSpread({}, defaultSyntax);
  
  var TYPES = {
    n: "number",
    s: "string",
    b: "boolean"
  };
  
  function resolveDefs(c, syn, block, def) {
    return (typeof block === "string" ? block : block.toString()).replace(syn.define, function (_, code, assign, value) {
      if (code.indexOf("def.") === 0) {
        code = code.substring(4);
      }
  
      if (!(code in def)) {
        if (assign === ":") {
          value.replace(syn.defineParams, function (_, param, v) {
            def[code] = {
              arg: param,
              text: v
            };
          });
          if (!(code in def)) def[code] = value;
        } else {
          new Function("def", "def['".concat(code, "']=").concat(value))(def);
        }
      }
  
      return "";
    }).replace(syn.use, function (_, code) {
      code = code.replace(syn.useParams, function (_, s, d, param) {
        if (def[d] && def[d].arg && param) {
          var rw = unescape((d + ":" + param).replace(/'|\\/g, "_"));
          def.__exp = def.__exp || {};
          def.__exp[rw] = def[d].text.replace(new RegExp("(^|[^\\w$])".concat(def[d].arg, "([^\\w$])"), "g"), "$1".concat(param, "$2"));
          return s + "def.__exp['".concat(rw, "']");
        }
      });
      var v = new Function("def", "return " + code)(def);
      return v ? resolveDefs(c, syn, v, def) : v;
    });
  }
  
  function unescape(code) {
    return code.replace(/\\('|\\)/g, "$1").replace(/[\r\t\n]/g, " ");
  }
  
  function template(tmpl, c, def) {
    var ds = c && c.delimiters;
    var syn = ds && !sameDelimiters(ds) ? getSyntax(ds) : currentSyntax;
    c = c ? _objectSpread(_objectSpread({}, templateSettings), c) : templateSettings;
    var sid = 0;
    var str = resolveDefs(c, syn, tmpl, def || {});
    var needEncoders = {};
    str = ("let out='" + (c.strip ? str.trim().replace(/[\t ]+(\r|\n)/g, "\n") // remove trailing spaces
    .replace(/(\r|\n)[\t ]+/g, " ") // leading spaces reduced to " "
    .replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g, "") // remove breaks, tabs and JS comments
    : str).replace(/'|\\/g, "\\$&").replace(syn.interpolate, function (_, code) {
      return "'+(".concat(unescape(code), ")+'");
    }).replace(syn.typeInterpolate, function (_, typ, code) {
      sid++;
      var val = c.internalPrefix + sid;
      var error = "throw new Error(\"expected ".concat(TYPES[typ], ", got \"+ (typeof ").concat(val, "))");
      return "';const ".concat(val, "=(").concat(unescape(code), ");if(typeof ").concat(val, "!==\"").concat(TYPES[typ], "\") ").concat(error, ";out+=").concat(val, "+'");
    }).replace(syn.encode, function (_) {
      var enc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var code = arguments.length > 2 ? arguments[2] : undefined;
      needEncoders[enc] = true;
      code = unescape(code);
      var e = c.selfContained ? enc : enc ? "." + enc : '[""]';
      return "'+".concat(c.encodersPrefix).concat(e, "(").concat(code, ")+'");
    }).replace(syn.conditional, function (_, elseCase, code) {
      if (code) {
        code = unescape(code);
        return elseCase ? "';}else if(".concat(code, "){out+='") : "';if(".concat(code, "){out+='");
      }
  
      return elseCase ? "';}else{out+='" : "';}out+='";
    }).replace(syn.iterate, function (_, arr, vName, iName) {
      if (!arr) return "';} } out+='";
      sid++;
      var defI = iName ? "let ".concat(iName, "=-1;") : "";
      var incI = iName ? "".concat(iName, "++;") : "";
      var val = c.internalPrefix + sid;
      return "';const ".concat(val, "=").concat(unescape(arr), ";if(").concat(val, "){").concat(defI, "for (const ").concat(vName, " of ").concat(val, "){").concat(incI, "out+='");
    }).replace(syn.evaluate, function (_, code) {
      return "';".concat(unescape(code), "out+='");
    }) + "';return out;").replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r").replace(/(\s|;|\}|^|\{)out\+='';/g, "$1").replace(/\+''/g, "");
    var args = Array.isArray(c.argName) ? properties(c.argName) : c.argName;
  
    if (Object.keys(needEncoders).length === 0) {
      return try_(function () {
        return new Function(args, str);
      });
    }
  
    checkEncoders(c, needEncoders);
    str = "return function(".concat(args, "){").concat(str, "};");
    return try_(function () {
      return c.selfContained ? new Function(str = addEncoders(c, needEncoders) + str)() : new Function(c.encodersPrefix, str)(c.encoders);
    });
  
    function try_(f) {
      try {
        return f();
      } catch (e) {
        console.log("Could not create a template function: " + str);
        throw e;
      }
    }
  }
  
  function compile(tmpl, def) {
    return template(tmpl, null, def);
  }
  
  function sameDelimiters(_ref) {
    var start = _ref.start,
        end = _ref.end;
    var d = templateSettings.delimiters;
    return d.start === start && d.end === end;
  }
  
  function setDelimiters(delimiters) {
    if (sameDelimiters(delimiters)) {
      console.log("delimiters did not change");
      return;
    }
  
    currentSyntax = getSyntax(delimiters);
    templateSettings.delimiters = delimiters;
  }
  
  function getSyntax(_ref2) {
    var start = _ref2.start,
        end = _ref2.end;
    start = escape(start);
    end = escape(end);
    var syntax = {};
  
    for (var syn in defaultSyntax) {
      var s = defaultSyntax[syn].toString().replace(/\\\{\\\{/g, start).replace(/\\\}\\\}/g, end);
      syntax[syn] = strToRegExp(s);
    }
  
    return syntax;
  }
  
  var escapeCharacters = /([{}[\]()<>\\\/^$\-.+*?!=|&:])/g;
  
  function escape(str) {
    return str.replace(escapeCharacters, "\\$1");
  }
  
  var regexpPattern = /^\/(.*)\/([\w]*)$/;
  
  function strToRegExp(str) {
    var _str$match = str.match(regexpPattern),
        _str$match2 = (0, _slicedToArray2.default)(_str$match, 3),
        rx = _str$match2[1],
        flags = _str$match2[2];
  
    return new RegExp(rx, flags);
  }
  
  function properties(args) {
    return args.reduce(function (s, a, i) {
      return s + (i ? "," : "") + a;
    }, "{") + "}";
  }
  
  function checkEncoders(c, encoders) {
    var typ = encoderType[c.selfContained];
  
    for (var enc in encoders) {
      var e = c.encoders[enc];
      if (!e) throw new Error("unknown encoder \"".concat(enc, "\""));
      if ((0, _typeof2.default)(e) !== typ) throw new Error("selfContained ".concat(c.selfContained, ": encoder type must be \"").concat(typ, "\""));
    }
  }
  
  function addEncoders(c, encoders) {
    var s = "";
  
    for (var enc in encoders) {
      s += "const ".concat(c.encodersPrefix).concat(enc, "=").concat(c.encoders[enc], ";");
    }
  
    return s;
  }
  
  },{"@babel/runtime/helpers/defineProperty":9,"@babel/runtime/helpers/interopRequireDefault":12,"@babel/runtime/helpers/slicedToArray":17,"@babel/runtime/helpers/typeof":18}],39:[function(require,module,exports){
  "use strict";
  
  window.firstCustomizeEventCall = true;
  var _targets = {
    selectQuestion: "section_id:change",
    closeQuestion: "section:close",
    addQuestion: "section:add",
    addAnswer: "block:add",
    updateSetting: "setting:update",
    reorderQuestion: "section:reorder",
    reorderAnswer: "block:reorder",
    deleteQuestion: "section:remove",
    deleteAnswer: "block:remove",
    initialize: "state:set"
  };
  
  function handleQuizEvent(e) {
    var data = e.data,
        target = e.target;
    if (!data.state) return;
    var newInstance = new window._QuizMaster({
      anchor_id: "#quiz-scene",
      meta: {
        shop: query.shop,
        id: "quiz-v1",
        v: "1",
        page: "quiz"
      },
      configurations: data.state
    });
    if (!window.quiz.instances.length) window.quiz.instances.push(newInstance);
    var quizInstance = window.quiz.instances[0];
  
    if (firstCustomizeEventCall) {
      quizInstance.remount(data.state);
      firstCustomizeEventCall = false;
    }
  
    var withoutRemount = target === _targets.updateSetting && !data.global_section_id || target === _targets.addAnswer || target === _targets.reorderAnswer || target === _targets.deleteAnswer;
    if (target === _targets.selectQuestion && data.section_id) data.state.all_steps = data.state.all_steps.filter(function (step) {
      return step.id === data.section_id;
    });
    quizInstance[withoutRemount ? 'reloadStep' : 'remount'](data.state);
    return true;
  }
  
  function handleResultsEvent(e) {
    var data = e.data,
        query = e.query,
        target = e.target;
    if (!data.state) return;
    var newInstance = new window._ResultsMaster({
      anchor_id: "#quiz-scene",
      meta: {
        shop: query.shop,
        id: "quiz-results-v1",
        v: "1"
      },
      modules: data.state.modules || []
    });
    if (!window.quizResults.instances.length) window.quizResults.instances.push(newInstance);
    var resultsInstance = window.quizResults.instances[0];
  
    if (data.state && data.state.modules) {
      var modules = data.state.modules;
      resultsInstance.remount(modules);
    }
  }
  
  function manageCustomizeEvents(e) {
    var page_id = e.data.page_id;
  
    switch (page_id) {
      case 'quiz':
        handleQuizEvent(e);
        break;
  
      case 'results':
        handleResultsEvent(e);
        break;
  
      default:
        break;
    }
  }
  /**
   * Event listener to handle incoming
   * events from Customize when user
   * action is detected
   *
   * Messages will only be treated if
   * they come from trusted domains
   *
   */
  
  
  var last_event = null;
  window.addEventListener('message', function (event) {
    var allowedDomains = ['https://customize.eu.ngrok.io', 'https://alfred-customize.ngrok.io', 'https://customize.kastorstudio.com', 'https://customize.dev-kastorstudio.com'];
    var allowed = false;
    allowedDomains.forEach(function (domain) {
      if (event.origin.startsWith(domain)) allowed = true;
    });
  
    if (allowed) {
      if (last_event && last_event.data === event.data && last_event.action === event.action && last_event.target === event.target) return;
      last_event = event;
      manageCustomizeEvents(event.data);
    } else return;
  });
  
  },{}],40:[function(require,module,exports){
  "use strict";
  
  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  
  var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
  
  var doT = require('./doT.js');
  
  module.exports = {
    inheritPrototype: function inheritPrototype(child, parent) {
      child.prototype = Object.create(parent.prototype);
      Object.defineProperty(child.prototype, "constructor", {
        value: child,
        enumerable: false,
        // so that it does not appear in 'for in' loop
        writable: true
      });
    },
  
    /**
     * Gets the value at `path` of `object`.
     * @param {Object}       object
     * @param {string|Array} path
     * @returns {*} value if exists else undefined
     */
    getProp: function getProp(object, path, value) {
      var pathArray = Array.isArray(path) ? path : path.split('.').filter(function (key) {
        return key;
      });
      var pathArrayFlat = pathArray.flatMap(function (part) {
        return typeof part === 'string' ? part.split('.') : part;
      });
      var foundValue = pathArrayFlat.reduce(function (obj, key) {
        return obj && obj[key];
      }, object);
      return foundValue || foundValue == false ? foundValue : value;
    },
  
    /**
     * Recursively merge properties of two objects
     * @param {Object}   defaults default settings
     * @param {Object}   settings user settings that should override the defaults.
     * @param {bool}     isRecursiveCall this is an internal param - SHOULD NOT BE USED BY AN EXTERNAL CALLER.
     * @returns {Object} Merged settings.
     */
    merge: function merge(defaults, settings, isRecursiveCall) {
      var merged, clonedSettings;
  
      if (!isRecursiveCall) {
        // Attention, potential data loss with (undefined, new Date(), Infinity, reg expr)
        // => ref: https://stackoverflow.com/a/122704/2517028
        merged = JSON.parse(JSON.stringify(defaults));
        clonedSettings = JSON.parse(JSON.stringify(settings));
      } else {
        merged = defaults;
        clonedSettings = settings;
      }
  
      for (var p in clonedSettings) {
        try {
          // Property in destination object set; update its value.
          if (clonedSettings[p].constructor == Object) merged[p] = MergeRecursive(merged[p], clonedSettings[p], true);else merged[p] = clonedSettings[p];
        } catch (e) {
          // Property in destination object not set; create it and set its value.
          merged[p] = clonedSettings[p];
        }
      }
  
      return merged;
    },
  
    /**
     * Build template - using DOT.js
     * ref => https://olado.github.io/doT/
     *
     * @param {string}   id the id of the template
     * @param {Object}   config the template config
     * @returns {string} HTML rendered template.
     */
    renderTemplate: function renderTemplate(id, config) {
      var templateSettings = {
        argName: "zerance",
        encoders: {},
        selfContained: false,
        strip: true,
        internalPrefix: "_val",
        encodersPrefix: "_enc",
        delimiters: {
          start: "{$",
          end: "}}"
        }
      };
  
      try {
        var tempFn = doT.template(document.getElementById(id).innerHTML, templateSettings);
        return tempFn(config);
      } catch (e) {
        console.error("Error rendering template", e, [arguments]);
        return "Error rendering template";
      }
    },
  
    /**
     * Generate a random string.
     * ref => https://stackoverflow.com/a/1349426/2517028
     *
     * @param {int}     length The length of the generated string.
     * @param {Object}  settings
     * @param {string}  settings.prefix
     * @param {string}  settings.postfix
     * @return {string} The generated string.
     */
    makeId: function makeId(length, settings) {
      var result = [];
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
  
      while (result.length <= length) {
        result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));
      }
  
      return "".concat(settings.prefix ? settings.prefix : "").concat(result.join('')).concat(settings.postfix ? settings.postfix : "");
    },
  
    /**
     * Creates style tag with the specified styles within.
     * The styles are either a string that gets attached directly or an object that gets parsed and then added one by one.
     *
     * @param {object} options        options for the import.
     * @param {String} options.url    styles to add from a URL.
     * @param {String} options.string styles to add directly as a string.
     * ex: options.string: "#root {color: white}"
     * @param {Object} options.object styles object
     * @param {Object} options.object.css_selector = css object.
     * @param {Object} options.object.min_width
     * @param {Object} options.object.max_width
     * ex. {"#xxx .button": "background-color: black; margin: 15px;"}
     */
    loadStyles: function loadStyles(options) {
      var style = document.createElement('style');
      style.setAttribute("type", "text/css");
      if (options.url) style.setAttribute("href", options.url);else if (options.string) style.innerHTML = options.string;else if (options.object) {
        var styles = options.object;
        var minWidth = !isNaN(parseInt(options.min_width)) ? options.min_width : false;
        var maxWidth = !isNaN(parseInt(options.max_width)) ? options.max_width : false;
        var isMediaQuery = minWidth || maxWidth;
        style.innerHTML = !isMediaQuery ? "" : "@media screen ".concat(minWidth ? " and (min-width: ".concat(minWidth, ") ") : "", " ").concat(maxWidth ? " and (max-width: ".concat(maxWidth, ") ") : "", " {");
  
        for (var selector in styles) {
          var stylesObject = styles[selector]; // convert JSON styles into CSS string, ref: https://stackoverflow.com/a/45205645/2517028.
  
          var styleString = Object.entries(stylesObject).map(function (_ref) {
            var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
                k = _ref2[0],
                v = _ref2[1];
  
            var key = k.replace(/[A-Z]/g, function (match) {
              return "-".concat(match.toLowerCase());
            });
            var val = key == "background-image" || key == "background" && v.includes("http") ? "url(".concat(v, ")") : v;
            return v && typeof v === 'string' && v.trim() !== "" ? "".concat(key, ":").concat(val) : "";
          }).join(';');
          style.innerHTML += "".concat(selector, " { ").concat(styleString, " }");
        }
  
        style.innerHTML += !isMediaQuery ? "" : "}";
      }
      document.getElementsByTagName('head')[0].appendChild(style);
    },
  
    /**
     * Loads multiple scripts async, by creating a script tag in the head.
     *
     * @param {array}    scripts links of the scripts to create.
     * @param {function} completedCallback a callback indicating all scripts are fully loaded.
     * @param {function} individualSuccessCallback a callback indicating a specific script is loaded, takes {string} param for the url of the script.
     */
    loadScript: function loadScript(scripts, completedCallback, individualSuccessCallback) {
      var prot = !document.location.protocol.includes('http') ? "" : "https:" === document.location.protocol ? "https://" : "http://";
  
      function checkStateAndCall(path, callback) {
        var _success = false;
        return function () {
          if (!_success && (!this.readyState || this.readyState == 'complete')) {
            _success = true;
            individualSuccessCallback(path);
            callback();
          }
        };
      }
  
      function asyncLoadScripts(files) {
        function loadNext() {
          // chain element
          if (!files.length) return completedCallback();
          var path = files.shift();
          if (typeof path !== 'string' || path.trim() == "") return completedCallback();
          var scriptElm = document.createElement('script');
          scriptElm.type = 'text/javascript';
          scriptElm.async = true;
          scriptElm.src = prot + path;
          scriptElm.onload = scriptElm.onreadystatechange = checkStateAndCall(path, loadNext); // load next file in chain when
          // this one will be ready
  
          var headElm = document.head || document.getElementsByTagName('head')[0];
          headElm.appendChild(scriptElm);
        }
  
        loadNext(); // start a chain
      }
  
      asyncLoadScripts(scripts);
    },
    htmlToElement: function htmlToElement(html) {
      var template = document.createElement('template');
      html = html.trim(); // Never return a text node of whitespace as the result
  
      template.innerHTML = html;
      return template.content.firstChild;
    }
  };
  
  },{"./doT.js":38,"@babel/runtime/helpers/interopRequireDefault":12,"@babel/runtime/helpers/slicedToArray":17}],41:[function(require,module,exports){
  "use strict";
  
  (function () {
    var _QuizTrackers = {};
    /**
    * Tracker to know when the user
    * started the quiz
    */
    // TODO: A revoir. (il faut quand on clic sur quelquechose)
  
    var startedAt = Date.now();
    _QuizTrackers.startedAt = startedAt;
    /**
    * Track the origin of the user
    * comes up on the quiz
    */
  
    var urlParams = new URLSearchParams(window.location.search);
    var origin = urlParams.get('origin');
    _QuizTrackers.origin = origin || 'unknown';
    /**
    * Tracker to locate the ip address
    * of the user (country/city)
    */
  
    /**
    * Tracker for time spent on
    * the quiz and answers of the user
    */
  
    window.onbeforeunload = function () {
      /** Time spent */
      var secondsSpent = (Date.now() - startedAt) / 1000;
      _QuizTrackers.timeSpent = secondsSpent;
      /** Questions & Answers */
      // _zeranceQuizTrackers.steps = zeranceQuizManager.getSteps();
      // TODO: call a route to upload session data
    }; // is_submit pour envoyer les meta info.
    // window.sendAnswer = function (add_answer, id, v, is_submit) {
    //   var session_token = getCookie(`kqb_session_${id}`);
    //   if (!session_token) {
    //     return (console.error("[KASTOR] Unable to retrieve quiz session id."));
    //   }
    //   var xhr = new XMLHttpRequest();
    //   xhr.open("POST", '/apps/quiz', true);
    //   xhr.setRequestHeader("Content-type", "application/json");
    //   xhr.send(JSON.stringify({
    //     session_token,
    //     add_answer
    //   }));
    // }
    // window.deleteAnswer = function (add_answer, id, v, is_submit) {
    //   var session_token = getCookie(`kqb_session_${id}`);
    //   if (!session_token) {
    //     return (console.error("[KASTOR] Unable to retrieve quiz session id."));
    //   }
    //   var xhr = new XMLHttpRequest();
    //   xhr.open("POST", '/apps/quiz', true);
    //   xhr.setRequestHeader("Content-type", "application/json");
    //   xhr.send(JSON.stringify({
    //     session_token,
    //     add_answer
    //   }));
    // }
  
  })();
  
  },{}]},{},[24])
  
  //# sourceMappingURL=sz_quiz.js.map
  